import type { LatLon } from "@radar-sim/schema";

/**
 * Coastline polylines derived from OpenStreetMap data via Overpass API,
 * clipped to the solent bounding box and Douglas–Peucker simplified
 * at ~33 m tolerance. Re-fetch with /tmp/fetch-coastline.mjs.
 *
 * Convention:
 *   - SOLENT_MAINLAND is an OPEN polyline along the mainland's seaward edge,
 *     clipped at the bounding-box left/right margins. Renderers close it
 *     by extending to the chart's top edge.
 *   - SOLENT_ISLANDS are CLOSED polygons (first === last point). Includes
 *     islands and any inland water features that would draw as land.
 *
 * © OpenStreetMap contributors, ODbL.
 */

export const SOLENT_MAINLAND: ReadonlyArray<LatLon> = [
  { lat: 50.68386, lon: -1.94971 },
  { lat: 50.68271, lon: -1.9477 },
  { lat: 50.68301, lon: -1.94598 },
  { lat: 50.6827, lon: -1.94557 },
  { lat: 50.68332, lon: -1.94563 },
  { lat: 50.68383, lon: -1.94433 },
  { lat: 50.68369, lon: -1.94335 },
  { lat: 50.68328, lon: -1.94347 },
  { lat: 50.68425, lon: -1.94281 },
  { lat: 50.68469, lon: -1.94123 },
  { lat: 50.68498, lon: -1.94154 },
  { lat: 50.68532, lon: -1.94116 },
  { lat: 50.68581, lon: -1.94014 },
  { lat: 50.68558, lon: -1.93956 },
  { lat: 50.68613, lon: -1.93981 },
  { lat: 50.68665, lon: -1.93822 },
  { lat: 50.68719, lon: -1.93856 },
  { lat: 50.68789, lon: -1.93692 },
  { lat: 50.68831, lon: -1.9372 },
  { lat: 50.69095, lon: -1.93351 },
  { lat: 50.69144, lon: -1.93359 },
  { lat: 50.69854, lon: -1.92339 },
  { lat: 50.70443, lon: -1.91277 },
  { lat: 50.7075, lon: -1.90408 },
  { lat: 50.70951, lon: -1.89982 },
  { lat: 50.71248, lon: -1.89035 },
  { lat: 50.71714, lon: -1.86675 },
  { lat: 50.7196, lon: -1.84164 },
  { lat: 50.72063, lon: -1.81865 },
  { lat: 50.72007, lon: -1.80418 },
  { lat: 50.71622, lon: -1.76701 },
  { lat: 50.71337, lon: -1.7542 },
  { lat: 50.71167, lon: -1.74893 },
  { lat: 50.71106, lon: -1.74883 },
  { lat: 50.71237, lon: -1.74878 },
  { lat: 50.71409, lon: -1.74513 },
  { lat: 50.71509, lon: -1.74507 },
  { lat: 50.71909, lon: -1.74203 },
  { lat: 50.71947, lon: -1.74127 },
  { lat: 50.71978, lon: -1.74158 },
  { lat: 50.7217, lon: -1.74049 },
  { lat: 50.7238, lon: -1.74012 },
  { lat: 50.72228, lon: -1.7428 },
  { lat: 50.72017, lon: -1.74288 },
  { lat: 50.71851, lon: -1.74384 },
  { lat: 50.71798, lon: -1.74466 },
  { lat: 50.71809, lon: -1.74672 },
  { lat: 50.7173, lon: -1.74581 },
  { lat: 50.71668, lon: -1.74578 },
  { lat: 50.71694, lon: -1.74666 },
  { lat: 50.71609, lon: -1.74664 },
  { lat: 50.71605, lon: -1.74601 },
  { lat: 50.71556, lon: -1.74605 },
  { lat: 50.71552, lon: -1.74796 },
  { lat: 50.71629, lon: -1.749 },
  { lat: 50.71601, lon: -1.7468 },
  { lat: 50.71699, lon: -1.74684 },
  { lat: 50.71709, lon: -1.74786 },
  { lat: 50.71754, lon: -1.74796 },
  { lat: 50.71731, lon: -1.75061 },
  { lat: 50.71763, lon: -1.75057 },
  { lat: 50.71789, lon: -1.74829 },
  { lat: 50.71763, lon: -1.74862 },
  { lat: 50.71754, lon: -1.74712 },
  { lat: 50.71777, lon: -1.74684 },
  { lat: 50.71789, lon: -1.74751 },
  { lat: 50.71766, lon: -1.74669 },
  { lat: 50.71801, lon: -1.74704 },
  { lat: 50.71862, lon: -1.75162 },
  { lat: 50.71846, lon: -1.75638 },
  { lat: 50.7177, lon: -1.75933 },
  { lat: 50.71805, lon: -1.76139 },
  { lat: 50.71906, lon: -1.76293 },
  { lat: 50.71884, lon: -1.76359 },
  { lat: 50.71958, lon: -1.76386 },
  { lat: 50.71977, lon: -1.76526 },
  { lat: 50.72017, lon: -1.76345 },
  { lat: 50.71968, lon: -1.76386 },
  { lat: 50.71882, lon: -1.76326 },
  { lat: 50.7191, lon: -1.7624 },
  { lat: 50.71959, lon: -1.76262 },
  { lat: 50.71978, lon: -1.76219 },
  { lat: 50.72006, lon: -1.76291 },
  { lat: 50.72029, lon: -1.76205 },
  { lat: 50.71986, lon: -1.76096 },
  { lat: 50.72018, lon: -1.76085 },
  { lat: 50.72187, lon: -1.76692 },
  { lat: 50.72371, lon: -1.76837 },
  { lat: 50.72499, lon: -1.7687 },
  { lat: 50.72529, lon: -1.76776 },
  { lat: 50.72633, lon: -1.76814 },
  { lat: 50.72727, lon: -1.76946 },
  { lat: 50.72822, lon: -1.77229 },
  { lat: 50.72969, lon: -1.77391 },
  { lat: 50.72995, lon: -1.77626 },
  { lat: 50.72907, lon: -1.7782 },
  { lat: 50.72966, lon: -1.77731 },
  { lat: 50.72888, lon: -1.78045 },
  { lat: 50.72962, lon: -1.78169 },
  { lat: 50.73, lon: -1.78414 },
  { lat: 50.72915, lon: -1.78835 },
  { lat: 50.72946, lon: -1.78804 },
  { lat: 50.72948, lon: -1.78982 },
  { lat: 50.73011, lon: -1.78929 },
  { lat: 50.73068, lon: -1.79017 },
  { lat: 50.73019, lon: -1.78898 },
  { lat: 50.73072, lon: -1.78875 },
  { lat: 50.73017, lon: -1.78891 },
  { lat: 50.72966, lon: -1.78692 },
  { lat: 50.73008, lon: -1.78559 },
  { lat: 50.72988, lon: -1.787 },
  { lat: 50.73042, lon: -1.78604 },
  { lat: 50.73047, lon: -1.78329 },
  { lat: 50.72986, lon: -1.77988 },
  { lat: 50.73074, lon: -1.77627 },
  { lat: 50.73037, lon: -1.775 },
  { lat: 50.73095, lon: -1.77457 },
  { lat: 50.73025, lon: -1.77386 },
  { lat: 50.73028, lon: -1.77152 },
  { lat: 50.73076, lon: -1.77129 },
  { lat: 50.72996, lon: -1.77038 },
  { lat: 50.72987, lon: -1.77137 },
  { lat: 50.72923, lon: -1.77165 },
  { lat: 50.72824, lon: -1.77111 },
  { lat: 50.72775, lon: -1.76903 },
  { lat: 50.72859, lon: -1.76733 },
  { lat: 50.72847, lon: -1.76609 },
  { lat: 50.7298, lon: -1.76524 },
  { lat: 50.73111, lon: -1.76357 },
  { lat: 50.7291, lon: -1.76565 },
  { lat: 50.72623, lon: -1.76642 },
  { lat: 50.72605, lon: -1.76693 },
  { lat: 50.72385, lon: -1.76504 },
  { lat: 50.72311, lon: -1.76181 },
  { lat: 50.7237, lon: -1.76132 },
  { lat: 50.7243, lon: -1.7619 },
  { lat: 50.72396, lon: -1.76256 },
  { lat: 50.72448, lon: -1.76269 },
  { lat: 50.72428, lon: -1.76196 },
  { lat: 50.72525, lon: -1.76215 },
  { lat: 50.72561, lon: -1.76295 },
  { lat: 50.72504, lon: -1.76418 },
  { lat: 50.72595, lon: -1.76299 },
  { lat: 50.72636, lon: -1.76316 },
  { lat: 50.72636, lon: -1.76413 },
  { lat: 50.72706, lon: -1.76373 },
  { lat: 50.72624, lon: -1.76407 },
  { lat: 50.72669, lon: -1.76313 },
  { lat: 50.72571, lon: -1.76307 },
  { lat: 50.72524, lon: -1.76181 },
  { lat: 50.7237, lon: -1.7602 },
  { lat: 50.72378, lon: -1.7579 },
  { lat: 50.724, lon: -1.75917 },
  { lat: 50.72454, lon: -1.75914 },
  { lat: 50.72429, lon: -1.75954 },
  { lat: 50.72456, lon: -1.75918 },
  { lat: 50.72496, lon: -1.75961 },
  { lat: 50.72526, lon: -1.75917 },
  { lat: 50.72552, lon: -1.75987 },
  { lat: 50.72597, lon: -1.759 },
  { lat: 50.7269, lon: -1.75952 },
  { lat: 50.72584, lon: -1.75831 },
  { lat: 50.7266, lon: -1.75762 },
  { lat: 50.72599, lon: -1.75618 },
  { lat: 50.72736, lon: -1.75649 },
  { lat: 50.72799, lon: -1.75743 },
  { lat: 50.7274, lon: -1.76014 },
  { lat: 50.72771, lon: -1.76231 },
  { lat: 50.7278, lon: -1.76176 },
  { lat: 50.72815, lon: -1.76225 },
  { lat: 50.72746, lon: -1.76014 },
  { lat: 50.72814, lon: -1.75726 },
  { lat: 50.72847, lon: -1.75795 },
  { lat: 50.72818, lon: -1.7586 },
  { lat: 50.72866, lon: -1.75765 },
  { lat: 50.72902, lon: -1.75793 },
  { lat: 50.72908, lon: -1.75999 },
  { lat: 50.72924, lon: -1.75773 },
  { lat: 50.72976, lon: -1.75853 },
  { lat: 50.72935, lon: -1.75759 },
  { lat: 50.73015, lon: -1.75916 },
  { lat: 50.72946, lon: -1.75734 },
  { lat: 50.7304, lon: -1.75698 },
  { lat: 50.73107, lon: -1.75733 },
  { lat: 50.72941, lon: -1.75532 },
  { lat: 50.72699, lon: -1.75369 },
  { lat: 50.72586, lon: -1.75062 },
  { lat: 50.72707, lon: -1.74579 },
  { lat: 50.72763, lon: -1.74571 },
  { lat: 50.72718, lon: -1.74704 },
  { lat: 50.72777, lon: -1.74674 },
  { lat: 50.72765, lon: -1.74367 },
  { lat: 50.72836, lon: -1.74367 },
  { lat: 50.72761, lon: -1.74347 },
  { lat: 50.7272, lon: -1.74068 },
  { lat: 50.72638, lon: -1.74084 },
  { lat: 50.72612, lon: -1.7414 },
  { lat: 50.72567, lon: -1.74116 },
  { lat: 50.72555, lon: -1.74185 },
  { lat: 50.72422, lon: -1.7426 },
  { lat: 50.72354, lon: -1.74235 },
  { lat: 50.72689, lon: -1.73696 },
  { lat: 50.72716, lon: -1.73552 },
  { lat: 50.72863, lon: -1.73401 },
  { lat: 50.72894, lon: -1.73419 },
  { lat: 50.73114, lon: -1.73146 },
  { lat: 50.73383, lon: -1.72532 },
  { lat: 50.73555, lon: -1.71779 },
  { lat: 50.73672, lon: -1.70733 },
  { lat: 50.73678, lon: -1.69845 },
  { lat: 50.73631, lon: -1.6979 },
  { lat: 50.73677, lon: -1.69777 },
  { lat: 50.73688, lon: -1.69586 },
  { lat: 50.73673, lon: -1.69439 },
  { lat: 50.73621, lon: -1.69424 },
  { lat: 50.73688, lon: -1.69399 },
  { lat: 50.73684, lon: -1.69238 },
  { lat: 50.73741, lon: -1.69254 },
  { lat: 50.73749, lon: -1.6893 },
  { lat: 50.73511, lon: -1.67071 },
  { lat: 50.73528, lon: -1.66908 },
  { lat: 50.73468, lon: -1.66669 },
  { lat: 50.73505, lon: -1.66635 },
  { lat: 50.73421, lon: -1.66166 },
  { lat: 50.7346, lon: -1.66131 },
  { lat: 50.73445, lon: -1.65891 },
  { lat: 50.73353, lon: -1.65498 },
  { lat: 50.73358, lon: -1.65267 },
  { lat: 50.73273, lon: -1.64995 },
  { lat: 50.73333, lon: -1.64703 },
  { lat: 50.73193, lon: -1.64192 },
  { lat: 50.73212, lon: -1.64045 },
  { lat: 50.72866, lon: -1.62707 },
  { lat: 50.71924, lon: -1.58462 },
  { lat: 50.7177, lon: -1.58061 },
  { lat: 50.71532, lon: -1.57739 },
  { lat: 50.71533, lon: -1.57624 },
  { lat: 50.70871, lon: -1.56465 },
  { lat: 50.70612, lon: -1.55514 },
  { lat: 50.70631, lon: -1.55048 },
  { lat: 50.70834, lon: -1.54794 },
  { lat: 50.70836, lon: -1.5495 },
  { lat: 50.70891, lon: -1.55047 },
  { lat: 50.71155, lon: -1.55282 },
  { lat: 50.71329, lon: -1.5537 },
  { lat: 50.71436, lon: -1.55516 },
  { lat: 50.71385, lon: -1.55511 },
  { lat: 50.71272, lon: -1.55364 },
  { lat: 50.71171, lon: -1.55417 },
  { lat: 50.71069, lon: -1.55375 },
  { lat: 50.70858, lon: -1.55386 },
  { lat: 50.70785, lon: -1.5526 },
  { lat: 50.70679, lon: -1.55189 },
  { lat: 50.70678, lon: -1.55381 },
  { lat: 50.70931, lon: -1.55629 },
  { lat: 50.70845, lon: -1.55704 },
  { lat: 50.70729, lon: -1.55525 },
  { lat: 50.70775, lon: -1.55641 },
  { lat: 50.70765, lon: -1.55671 },
  { lat: 50.70732, lon: -1.55615 },
  { lat: 50.70711, lon: -1.5566 },
  { lat: 50.7075, lon: -1.55795 },
  { lat: 50.70928, lon: -1.55881 },
  { lat: 50.70911, lon: -1.5594 },
  { lat: 50.70766, lon: -1.55867 },
  { lat: 50.70817, lon: -1.55899 },
  { lat: 50.70782, lon: -1.55933 },
  { lat: 50.70803, lon: -1.56002 },
  { lat: 50.70872, lon: -1.56037 },
  { lat: 50.70829, lon: -1.56096 },
  { lat: 50.70882, lon: -1.56177 },
  { lat: 50.70948, lon: -1.5616 },
  { lat: 50.70884, lon: -1.56262 },
  { lat: 50.70917, lon: -1.56257 },
  { lat: 50.7101, lon: -1.56599 },
  { lat: 50.71064, lon: -1.56577 },
  { lat: 50.71027, lon: -1.56636 },
  { lat: 50.71079, lon: -1.56607 },
  { lat: 50.71128, lon: -1.56462 },
  { lat: 50.71046, lon: -1.56695 },
  { lat: 50.71508, lon: -1.57417 },
  { lat: 50.71828, lon: -1.58049 },
  { lat: 50.71651, lon: -1.57685 },
  { lat: 50.71732, lon: -1.5738 },
  { lat: 50.71701, lon: -1.57345 },
  { lat: 50.71743, lon: -1.57351 },
  { lat: 50.717, lon: -1.57251 },
  { lat: 50.71744, lon: -1.5722 },
  { lat: 50.71762, lon: -1.57296 },
  { lat: 50.721, lon: -1.5649 },
  { lat: 50.7219, lon: -1.56608 },
  { lat: 50.72239, lon: -1.56576 },
  { lat: 50.72252, lon: -1.56747 },
  { lat: 50.72313, lon: -1.5646 },
  { lat: 50.72207, lon: -1.56346 },
  { lat: 50.72115, lon: -1.56074 },
  { lat: 50.72213, lon: -1.55602 },
  { lat: 50.72333, lon: -1.55443 },
  { lat: 50.72385, lon: -1.55458 },
  { lat: 50.72765, lon: -1.55235 },
  { lat: 50.72847, lon: -1.5501 },
  { lat: 50.72825, lon: -1.5469 },
  { lat: 50.72689, lon: -1.54583 },
  { lat: 50.72737, lon: -1.54449 },
  { lat: 50.72969, lon: -1.54073 },
  { lat: 50.72941, lon: -1.54009 },
  { lat: 50.72987, lon: -1.54067 },
  { lat: 50.73436, lon: -1.53531 },
  { lat: 50.73487, lon: -1.5334 },
  { lat: 50.73708, lon: -1.53089 },
  { lat: 50.73839, lon: -1.53093 },
  { lat: 50.73934, lon: -1.53183 },
  { lat: 50.74023, lon: -1.5312 },
  { lat: 50.74142, lon: -1.53343 },
  { lat: 50.73876, lon: -1.53815 },
  { lat: 50.73976, lon: -1.54178 },
  { lat: 50.73902, lon: -1.53814 },
  { lat: 50.73967, lon: -1.53709 },
  { lat: 50.74188, lon: -1.53509 },
  { lat: 50.74219, lon: -1.53689 },
  { lat: 50.74303, lon: -1.53684 },
  { lat: 50.74486, lon: -1.53485 },
  { lat: 50.74379, lon: -1.53367 },
  { lat: 50.74426, lon: -1.5327 },
  { lat: 50.74241, lon: -1.53064 },
  { lat: 50.7445, lon: -1.52591 },
  { lat: 50.74505, lon: -1.5265 },
  { lat: 50.74715, lon: -1.52705 },
  { lat: 50.7488, lon: -1.52522 },
  { lat: 50.74978, lon: -1.52633 },
  { lat: 50.74959, lon: -1.52707 },
  { lat: 50.75108, lon: -1.52961 },
  { lat: 50.7531, lon: -1.52746 },
  { lat: 50.75404, lon: -1.52864 },
  { lat: 50.75454, lon: -1.52847 },
  { lat: 50.75795, lon: -1.53377 },
  { lat: 50.75889, lon: -1.53672 },
  { lat: 50.75908, lon: -1.5363 },
  { lat: 50.75982, lon: -1.53704 },
  { lat: 50.75997, lon: -1.53607 },
  { lat: 50.76022, lon: -1.53638 },
  { lat: 50.7616, lon: -1.53501 },
  { lat: 50.76229, lon: -1.53584 },
  { lat: 50.76265, lon: -1.53762 },
  { lat: 50.76382, lon: -1.53544 },
  { lat: 50.763, lon: -1.53377 },
  { lat: 50.76134, lon: -1.53342 },
  { lat: 50.75941, lon: -1.5346 },
  { lat: 50.75951, lon: -1.53536 },
  { lat: 50.75912, lon: -1.53086 },
  { lat: 50.75711, lon: -1.52909 },
  { lat: 50.75725, lon: -1.52867 },
  { lat: 50.75866, lon: -1.52831 },
  { lat: 50.75856, lon: -1.52749 },
  { lat: 50.75713, lon: -1.52673 },
  { lat: 50.75311, lon: -1.51397 },
  { lat: 50.75378, lon: -1.50805 },
  { lat: 50.75369, lon: -1.50078 },
  { lat: 50.75513, lon: -1.49605 },
  { lat: 50.7555, lon: -1.48531 },
  { lat: 50.75783, lon: -1.47849 },
  { lat: 50.75888, lon: -1.47077 },
  { lat: 50.75961, lon: -1.4693 },
  { lat: 50.75963, lon: -1.4677 },
  { lat: 50.76103, lon: -1.46234 },
  { lat: 50.7612, lon: -1.46545 },
  { lat: 50.76257, lon: -1.4663 },
  { lat: 50.76365, lon: -1.46514 },
  { lat: 50.76477, lon: -1.466 },
  { lat: 50.76489, lon: -1.46567 },
  { lat: 50.76442, lon: -1.46422 },
  { lat: 50.76271, lon: -1.46287 },
  { lat: 50.76283, lon: -1.46334 },
  { lat: 50.76185, lon: -1.46291 },
  { lat: 50.76181, lon: -1.46239 },
  { lat: 50.76122, lon: -1.46386 },
  { lat: 50.76133, lon: -1.46246 },
  { lat: 50.76078, lon: -1.46084 },
  { lat: 50.76203, lon: -1.45723 },
  { lat: 50.76237, lon: -1.44688 },
  { lat: 50.76455, lon: -1.43861 },
  { lat: 50.76556, lon: -1.42863 },
  { lat: 50.76636, lon: -1.42705 },
  { lat: 50.76656, lon: -1.42001 },
  { lat: 50.76746, lon: -1.41543 },
  { lat: 50.77067, lon: -1.4066 },
  { lat: 50.77167, lon: -1.4026 },
  { lat: 50.77282, lon: -1.40095 },
  { lat: 50.77523, lon: -1.39316 },
  { lat: 50.77668, lon: -1.39071 },
  { lat: 50.77705, lon: -1.39103 },
  { lat: 50.77543, lon: -1.39309 },
  { lat: 50.77331, lon: -1.39995 },
  { lat: 50.77138, lon: -1.40424 },
  { lat: 50.77088, lon: -1.40623 },
  { lat: 50.77096, lon: -1.40681 },
  { lat: 50.77147, lon: -1.40655 },
  { lat: 50.77123, lon: -1.4073 },
  { lat: 50.77201, lon: -1.40737 },
  { lat: 50.77323, lon: -1.40548 },
  { lat: 50.77527, lon: -1.40011 },
  { lat: 50.77691, lon: -1.3926 },
  { lat: 50.77804, lon: -1.39275 },
  { lat: 50.7778, lon: -1.39453 },
  { lat: 50.77731, lon: -1.39422 },
  { lat: 50.77759, lon: -1.39564 },
  { lat: 50.77734, lon: -1.395 },
  { lat: 50.77637, lon: -1.39744 },
  { lat: 50.77698, lon: -1.39733 },
  { lat: 50.77675, lon: -1.39857 },
  { lat: 50.77695, lon: -1.39811 },
  { lat: 50.77751, lon: -1.39819 },
  { lat: 50.77705, lon: -1.39797 },
  { lat: 50.77737, lon: -1.3975 },
  { lat: 50.77773, lon: -1.39767 },
  { lat: 50.77803, lon: -1.39882 },
  { lat: 50.77751, lon: -1.39882 },
  { lat: 50.78368, lon: -1.41268 },
  { lat: 50.78599, lon: -1.41318 },
  { lat: 50.78718, lon: -1.41401 },
  { lat: 50.78892, lon: -1.41212 },
  { lat: 50.78978, lon: -1.41174 },
  { lat: 50.7901, lon: -1.41208 },
  { lat: 50.79154, lon: -1.4111 },
  { lat: 50.79311, lon: -1.4119 },
  { lat: 50.79336, lon: -1.4112 },
  { lat: 50.79335, lon: -1.41306 },
  { lat: 50.79364, lon: -1.41191 },
  { lat: 50.7945, lon: -1.41248 },
  { lat: 50.79461, lon: -1.41192 },
  { lat: 50.79368, lon: -1.41167 },
  { lat: 50.79406, lon: -1.41138 },
  { lat: 50.79473, lon: -1.41181 },
  { lat: 50.79447, lon: -1.41293 },
  { lat: 50.79644, lon: -1.41268 },
  { lat: 50.79657, lon: -1.4135 },
  { lat: 50.79724, lon: -1.41298 },
  { lat: 50.79854, lon: -1.4131 },
  { lat: 50.79972, lon: -1.41403 },
  { lat: 50.79903, lon: -1.41924 },
  { lat: 50.80002, lon: -1.42289 },
  { lat: 50.80229, lon: -1.42444 },
  { lat: 50.80537, lon: -1.42058 },
  { lat: 50.80559, lon: -1.42683 },
  { lat: 50.80634, lon: -1.42946 },
  { lat: 50.80703, lon: -1.42914 },
  { lat: 50.80728, lon: -1.43077 },
  { lat: 50.80778, lon: -1.4306 },
  { lat: 50.80778, lon: -1.43168 },
  { lat: 50.80823, lon: -1.4309 },
  { lat: 50.80909, lon: -1.43145 },
  { lat: 50.80848, lon: -1.43372 },
  { lat: 50.80862, lon: -1.43601 },
  { lat: 50.81033, lon: -1.43837 },
  { lat: 50.81029, lon: -1.43996 },
  { lat: 50.81084, lon: -1.43923 },
  { lat: 50.81133, lon: -1.43985 },
  { lat: 50.81225, lon: -1.43978 },
  { lat: 50.81227, lon: -1.4402 },
  { lat: 50.81247, lon: -1.43963 },
  { lat: 50.81369, lon: -1.43928 },
  { lat: 50.81371, lon: -1.44034 },
  { lat: 50.81399, lon: -1.43941 },
  { lat: 50.81458, lon: -1.44449 },
  { lat: 50.81353, lon: -1.44561 },
  { lat: 50.81468, lon: -1.44557 },
  { lat: 50.81565, lon: -1.44678 },
  { lat: 50.81769, lon: -1.44643 },
  { lat: 50.81827, lon: -1.44675 },
  { lat: 50.81873, lon: -1.44751 },
  { lat: 50.81876, lon: -1.45072 },
  { lat: 50.81916, lon: -1.45113 },
  { lat: 50.82013, lon: -1.44858 },
  { lat: 50.81977, lon: -1.44675 },
  { lat: 50.8188, lon: -1.44452 },
  { lat: 50.81639, lon: -1.44471 },
  { lat: 50.81523, lon: -1.44292 },
  { lat: 50.81565, lon: -1.44246 },
  { lat: 50.8154, lon: -1.438 },
  { lat: 50.81495, lon: -1.43827 },
  { lat: 50.81349, lon: -1.43737 },
  { lat: 50.81258, lon: -1.43799 },
  { lat: 50.8116, lon: -1.43749 },
  { lat: 50.81041, lon: -1.43595 },
  { lat: 50.81091, lon: -1.43505 },
  { lat: 50.81123, lon: -1.42932 },
  { lat: 50.80941, lon: -1.42714 },
  { lat: 50.80956, lon: -1.42645 },
  { lat: 50.80881, lon: -1.42695 },
  { lat: 50.80861, lon: -1.42664 },
  { lat: 50.80792, lon: -1.42321 },
  { lat: 50.80817, lon: -1.42272 },
  { lat: 50.8072, lon: -1.41947 },
  { lat: 50.80566, lon: -1.41754 },
  { lat: 50.80466, lon: -1.41717 },
  { lat: 50.80347, lon: -1.41768 },
  { lat: 50.80235, lon: -1.41949 },
  { lat: 50.80128, lon: -1.41974 },
  { lat: 50.80078, lon: -1.41913 },
  { lat: 50.80089, lon: -1.41754 },
  { lat: 50.80156, lon: -1.41632 },
  { lat: 50.80078, lon: -1.41856 },
  { lat: 50.80154, lon: -1.41966 },
  { lat: 50.80205, lon: -1.41932 },
  { lat: 50.80321, lon: -1.41626 },
  { lat: 50.8024, lon: -1.41517 },
  { lat: 50.8017, lon: -1.41599 },
  { lat: 50.802, lon: -1.41523 },
  { lat: 50.80272, lon: -1.41518 },
  { lat: 50.80306, lon: -1.41606 },
  { lat: 50.80386, lon: -1.41407 },
  { lat: 50.80561, lon: -1.41348 },
  { lat: 50.80479, lon: -1.41184 },
  { lat: 50.80328, lon: -1.41341 },
  { lat: 50.8026, lon: -1.4118 },
  { lat: 50.80142, lon: -1.41093 },
  { lat: 50.80067, lon: -1.40895 },
  { lat: 50.80041, lon: -1.40922 },
  { lat: 50.79811, lon: -1.40836 },
  { lat: 50.79773, lon: -1.40875 },
  { lat: 50.79628, lon: -1.40864 },
  { lat: 50.79491, lon: -1.40783 },
  { lat: 50.79482, lon: -1.40581 },
  { lat: 50.79385, lon: -1.40728 },
  { lat: 50.79135, lon: -1.40506 },
  { lat: 50.78725, lon: -1.40723 },
  { lat: 50.78628, lon: -1.40831 },
  { lat: 50.78497, lon: -1.40459 },
  { lat: 50.78453, lon: -1.40124 },
  { lat: 50.78458, lon: -1.39776 },
  { lat: 50.7858, lon: -1.3928 },
  { lat: 50.78588, lon: -1.38973 },
  { lat: 50.78541, lon: -1.38922 },
  { lat: 50.78606, lon: -1.38841 },
  { lat: 50.78508, lon: -1.38159 },
  { lat: 50.78552, lon: -1.37997 },
  { lat: 50.78524, lon: -1.36606 },
  { lat: 50.78386, lon: -1.35345 },
  { lat: 50.78505, lon: -1.35022 },
  { lat: 50.78505, lon: -1.34649 },
  { lat: 50.78574, lon: -1.34249 },
  { lat: 50.78761, lon: -1.34051 },
  { lat: 50.79381, lon: -1.33661 },
  { lat: 50.79669, lon: -1.33313 },
  { lat: 50.80326, lon: -1.32749 },
  { lat: 50.80779, lon: -1.32088 },
  { lat: 50.811, lon: -1.3142 },
  { lat: 50.81524, lon: -1.30738 },
  { lat: 50.81969, lon: -1.30696 },
  { lat: 50.82053, lon: -1.30856 },
  { lat: 50.81851, lon: -1.31118 },
  { lat: 50.8188, lon: -1.30975 },
  { lat: 50.8169, lon: -1.30819 },
  { lat: 50.81451, lon: -1.30969 },
  { lat: 50.81346, lon: -1.31151 },
  { lat: 50.8146, lon: -1.31378 },
  { lat: 50.81471, lon: -1.3131 },
  { lat: 50.81541, lon: -1.31283 },
  { lat: 50.81548, lon: -1.31421 },
  { lat: 50.81584, lon: -1.31253 },
  { lat: 50.81573, lon: -1.31355 },
  { lat: 50.8162, lon: -1.3134 },
  { lat: 50.81634, lon: -1.31398 },
  { lat: 50.81548, lon: -1.31459 },
  { lat: 50.81642, lon: -1.31664 },
  { lat: 50.81669, lon: -1.31646 },
  { lat: 50.81675, lon: -1.31715 },
  { lat: 50.81639, lon: -1.31722 },
  { lat: 50.81695, lon: -1.31784 },
  { lat: 50.81697, lon: -1.31678 },
  { lat: 50.81771, lon: -1.3174 },
  { lat: 50.81661, lon: -1.31867 },
  { lat: 50.81839, lon: -1.32328 },
  { lat: 50.81647, lon: -1.32601 },
  { lat: 50.81732, lon: -1.32487 },
  { lat: 50.81775, lon: -1.32554 },
  { lat: 50.81869, lon: -1.32326 },
  { lat: 50.819, lon: -1.32384 },
  { lat: 50.82021, lon: -1.32385 },
  { lat: 50.82089, lon: -1.3227 },
  { lat: 50.82369, lon: -1.32272 },
  { lat: 50.82402, lon: -1.32157 },
  { lat: 50.82615, lon: -1.32444 },
  { lat: 50.82583, lon: -1.32591 },
  { lat: 50.82473, lon: -1.32675 },
  { lat: 50.8246, lon: -1.32789 },
  { lat: 50.82546, lon: -1.32652 },
  { lat: 50.82639, lon: -1.32611 },
  { lat: 50.828, lon: -1.3296 },
  { lat: 50.82746, lon: -1.33449 },
  { lat: 50.82829, lon: -1.33614 },
  { lat: 50.82646, lon: -1.33928 },
  { lat: 50.82694, lon: -1.33908 },
  { lat: 50.82696, lon: -1.33952 },
  { lat: 50.82935, lon: -1.33821 },
  { lat: 50.83232, lon: -1.34051 },
  { lat: 50.83319, lon: -1.33989 },
  { lat: 50.83456, lon: -1.34047 },
  { lat: 50.83581, lon: -1.34014 },
  { lat: 50.83735, lon: -1.33498 },
  { lat: 50.83872, lon: -1.33743 },
  { lat: 50.8401, lon: -1.33786 },
  { lat: 50.84093, lon: -1.33918 },
  { lat: 50.84117, lon: -1.33982 },
  { lat: 50.84072, lon: -1.34104 },
  { lat: 50.84169, lon: -1.33967 },
  { lat: 50.84259, lon: -1.34038 },
  { lat: 50.84479, lon: -1.34455 },
  { lat: 50.84606, lon: -1.34974 },
  { lat: 50.84596, lon: -1.3508 },
  { lat: 50.845, lon: -1.35163 },
  { lat: 50.84299, lon: -1.35227 },
  { lat: 50.84206, lon: -1.35331 },
  { lat: 50.84193, lon: -1.35405 },
  { lat: 50.84277, lon: -1.35322 },
  { lat: 50.84254, lon: -1.35417 },
  { lat: 50.8432, lon: -1.3528 },
  { lat: 50.84313, lon: -1.35318 },
  { lat: 50.84391, lon: -1.35263 },
  { lat: 50.8435, lon: -1.35383 },
  { lat: 50.84423, lon: -1.35273 },
  { lat: 50.84443, lon: -1.35349 },
  { lat: 50.84394, lon: -1.35381 },
  { lat: 50.8443, lon: -1.35415 },
  { lat: 50.84443, lon: -1.35367 },
  { lat: 50.84471, lon: -1.35405 },
  { lat: 50.84461, lon: -1.35306 },
  { lat: 50.84553, lon: -1.35285 },
  { lat: 50.8453, lon: -1.35392 },
  { lat: 50.84432, lon: -1.35483 },
  { lat: 50.8438, lon: -1.35429 },
  { lat: 50.84421, lon: -1.35479 },
  { lat: 50.84399, lon: -1.35544 },
  { lat: 50.84301, lon: -1.35492 },
  { lat: 50.84294, lon: -1.35563 },
  { lat: 50.84383, lon: -1.35561 },
  { lat: 50.84317, lon: -1.35609 },
  { lat: 50.84324, lon: -1.35698 },
  { lat: 50.84251, lon: -1.3559 },
  { lat: 50.84304, lon: -1.35686 },
  { lat: 50.84266, lon: -1.35726 },
  { lat: 50.84334, lon: -1.35717 },
  { lat: 50.84329, lon: -1.35628 },
  { lat: 50.84378, lon: -1.35595 },
  { lat: 50.84394, lon: -1.35725 },
  { lat: 50.84389, lon: -1.35591 },
  { lat: 50.84421, lon: -1.35689 },
  { lat: 50.84433, lon: -1.35636 },
  { lat: 50.84463, lon: -1.35656 },
  { lat: 50.84421, lon: -1.35556 },
  { lat: 50.84467, lon: -1.35569 },
  { lat: 50.84454, lon: -1.35493 },
  { lat: 50.84484, lon: -1.35538 },
  { lat: 50.8446, lon: -1.35484 },
  { lat: 50.84529, lon: -1.35453 },
  { lat: 50.84557, lon: -1.35581 },
  { lat: 50.84502, lon: -1.35585 },
  { lat: 50.84501, lon: -1.35624 },
  { lat: 50.8455, lon: -1.35627 },
  { lat: 50.84502, lon: -1.35687 },
  { lat: 50.84562, lon: -1.35617 },
  { lat: 50.84522, lon: -1.35774 },
  { lat: 50.84454, lon: -1.35734 },
  { lat: 50.84528, lon: -1.35821 },
  { lat: 50.84511, lon: -1.359 },
  { lat: 50.84416, lon: -1.35801 },
  { lat: 50.84373, lon: -1.35823 },
  { lat: 50.84342, lon: -1.35747 },
  { lat: 50.84304, lon: -1.35773 },
  { lat: 50.84354, lon: -1.35808 },
  { lat: 50.84317, lon: -1.35851 },
  { lat: 50.84361, lon: -1.35853 },
  { lat: 50.8429, lon: -1.3592 },
  { lat: 50.84287, lon: -1.3605 },
  { lat: 50.84352, lon: -1.36116 },
  { lat: 50.84375, lon: -1.36036 },
  { lat: 50.84468, lon: -1.36049 },
  { lat: 50.84508, lon: -1.35988 },
  { lat: 50.84528, lon: -1.36049 },
  { lat: 50.8468, lon: -1.36144 },
  { lat: 50.84698, lon: -1.36064 },
  { lat: 50.84653, lon: -1.36139 },
  { lat: 50.84518, lon: -1.35971 },
  { lat: 50.84552, lon: -1.35895 },
  { lat: 50.84605, lon: -1.35998 },
  { lat: 50.84585, lon: -1.36059 },
  { lat: 50.84633, lon: -1.36069 },
  { lat: 50.84561, lon: -1.35861 },
  { lat: 50.84576, lon: -1.35729 },
  { lat: 50.84648, lon: -1.35868 },
  { lat: 50.84592, lon: -1.35695 },
  { lat: 50.84661, lon: -1.35521 },
  { lat: 50.84691, lon: -1.35486 },
  { lat: 50.84811, lon: -1.35536 },
  { lat: 50.84826, lon: -1.35775 },
  { lat: 50.84757, lon: -1.35886 },
  { lat: 50.84833, lon: -1.35784 },
  { lat: 50.84857, lon: -1.35846 },
  { lat: 50.84752, lon: -1.3603 },
  { lat: 50.84885, lon: -1.35785 },
  { lat: 50.84945, lon: -1.35839 },
  { lat: 50.84996, lon: -1.36025 },
  { lat: 50.84886, lon: -1.36083 },
  { lat: 50.84778, lon: -1.36369 },
  { lat: 50.84895, lon: -1.36097 },
  { lat: 50.84953, lon: -1.36096 },
  { lat: 50.84929, lon: -1.36234 },
  { lat: 50.84975, lon: -1.36103 },
  { lat: 50.85029, lon: -1.36165 },
  { lat: 50.85037, lon: -1.36285 },
  { lat: 50.8497, lon: -1.36371 },
  { lat: 50.85048, lon: -1.3631 },
  { lat: 50.8504, lon: -1.36353 },
  { lat: 50.85089, lon: -1.36322 },
  { lat: 50.85126, lon: -1.3637 },
  { lat: 50.85105, lon: -1.3657 },
  { lat: 50.85186, lon: -1.3653 },
  { lat: 50.85278, lon: -1.36795 },
  { lat: 50.85267, lon: -1.36887 },
  { lat: 50.85175, lon: -1.36907 },
  { lat: 50.85129, lon: -1.36805 },
  { lat: 50.85163, lon: -1.36918 },
  { lat: 50.85126, lon: -1.36952 },
  { lat: 50.85232, lon: -1.36888 },
  { lat: 50.85316, lon: -1.36954 },
  { lat: 50.85295, lon: -1.37017 },
  { lat: 50.85345, lon: -1.37003 },
  { lat: 50.85375, lon: -1.37109 },
  { lat: 50.85298, lon: -1.37193 },
  { lat: 50.85337, lon: -1.3714 },
  { lat: 50.8541, lon: -1.37205 },
  { lat: 50.85444, lon: -1.37149 },
  { lat: 50.85479, lon: -1.37282 },
  { lat: 50.8544, lon: -1.37293 },
  { lat: 50.85491, lon: -1.37288 },
  { lat: 50.85499, lon: -1.37387 },
  { lat: 50.85377, lon: -1.37508 },
  { lat: 50.85503, lon: -1.37405 },
  { lat: 50.85453, lon: -1.37534 },
  { lat: 50.85514, lon: -1.37373 },
  { lat: 50.85584, lon: -1.37439 },
  { lat: 50.85437, lon: -1.37677 },
  { lat: 50.85528, lon: -1.37586 },
  { lat: 50.85477, lon: -1.37827 },
  { lat: 50.85597, lon: -1.37465 },
  { lat: 50.85641, lon: -1.37502 },
  { lat: 50.85635, lon: -1.37688 },
  { lat: 50.85649, lon: -1.37492 },
  { lat: 50.856, lon: -1.37453 },
  { lat: 50.85619, lon: -1.37407 },
  { lat: 50.85689, lon: -1.37431 },
  { lat: 50.85758, lon: -1.37617 },
  { lat: 50.85756, lon: -1.37822 },
  { lat: 50.85806, lon: -1.37812 },
  { lat: 50.85707, lon: -1.3804 },
  { lat: 50.85858, lon: -1.37839 },
  { lat: 50.85887, lon: -1.37915 },
  { lat: 50.85825, lon: -1.37966 },
  { lat: 50.85799, lon: -1.38124 },
  { lat: 50.85837, lon: -1.38049 },
  { lat: 50.85852, lon: -1.38106 },
  { lat: 50.85877, lon: -1.37985 },
  { lat: 50.85892, lon: -1.38138 },
  { lat: 50.8584, lon: -1.38248 },
  { lat: 50.85893, lon: -1.3815 },
  { lat: 50.85876, lon: -1.38317 },
  { lat: 50.85912, lon: -1.38248 },
  { lat: 50.85961, lon: -1.38323 },
  { lat: 50.85907, lon: -1.382 },
  { lat: 50.85941, lon: -1.38187 },
  { lat: 50.85912, lon: -1.38119 },
  { lat: 50.85958, lon: -1.38146 },
  { lat: 50.85912, lon: -1.38102 },
  { lat: 50.85931, lon: -1.37976 },
  { lat: 50.85996, lon: -1.38167 },
  { lat: 50.86135, lon: -1.3834 },
  { lat: 50.86037, lon: -1.3842 },
  { lat: 50.8605, lon: -1.38488 },
  { lat: 50.86068, lon: -1.38439 },
  { lat: 50.86108, lon: -1.38532 },
  { lat: 50.86084, lon: -1.38431 },
  { lat: 50.86136, lon: -1.38397 },
  { lat: 50.86147, lon: -1.38496 },
  { lat: 50.86139, lon: -1.38377 },
  { lat: 50.86192, lon: -1.38415 },
  { lat: 50.86159, lon: -1.3868 },
  { lat: 50.86182, lon: -1.38626 },
  { lat: 50.86219, lon: -1.38643 },
  { lat: 50.86182, lon: -1.38592 },
  { lat: 50.86211, lon: -1.38527 },
  { lat: 50.86242, lon: -1.38553 },
  { lat: 50.86213, lon: -1.38486 },
  { lat: 50.86245, lon: -1.38503 },
  { lat: 50.86396, lon: -1.38748 },
  { lat: 50.86394, lon: -1.38822 },
  { lat: 50.86335, lon: -1.38704 },
  { lat: 50.86296, lon: -1.38705 },
  { lat: 50.86394, lon: -1.38863 },
  { lat: 50.8642, lon: -1.38888 },
  { lat: 50.86467, lon: -1.38822 },
  { lat: 50.86515, lon: -1.38847 },
  { lat: 50.86581, lon: -1.38984 },
  { lat: 50.86561, lon: -1.39055 },
  { lat: 50.86653, lon: -1.38871 },
  { lat: 50.86629, lon: -1.38952 },
  { lat: 50.86665, lon: -1.38902 },
  { lat: 50.86732, lon: -1.38996 },
  { lat: 50.86665, lon: -1.39115 },
  { lat: 50.86685, lon: -1.39166 },
  { lat: 50.86964, lon: -1.39283 },
  { lat: 50.86863, lon: -1.39479 },
  { lat: 50.87078, lon: -1.39831 },
  { lat: 50.87084, lon: -1.39932 },
  { lat: 50.87137, lon: -1.39876 },
  { lat: 50.87184, lon: -1.40068 },
  { lat: 50.87456, lon: -1.3974 },
  { lat: 50.87566, lon: -1.3997 },
  { lat: 50.87764, lon: -1.39668 },
  { lat: 50.88302, lon: -1.39324 },
  { lat: 50.88298, lon: -1.39029 },
  { lat: 50.88822, lon: -1.3809 },
  { lat: 50.88633, lon: -1.37425 },
  { lat: 50.88419, lon: -1.36956 },
  { lat: 50.88178, lon: -1.36653 },
  { lat: 50.88026, lon: -1.36572 },
  { lat: 50.87602, lon: -1.35874 },
  { lat: 50.86984, lon: -1.35178 },
  { lat: 50.86238, lon: -1.33874 },
  { lat: 50.8572, lon: -1.33222 },
  { lat: 50.85174, lon: -1.32149 },
  { lat: 50.85007, lon: -1.31461 },
  { lat: 50.84892, lon: -1.31324 },
  { lat: 50.84894, lon: -1.31055 },
  { lat: 50.8466, lon: -1.30782 },
  { lat: 50.84332, lon: -1.3082 },
  { lat: 50.84067, lon: -1.30686 },
  { lat: 50.83776, lon: -1.30239 },
  { lat: 50.83316, lon: -1.2876 },
  { lat: 50.82698, lon: -1.26478 },
  { lat: 50.823, lon: -1.25614 },
  { lat: 50.81721, lon: -1.24614 },
  { lat: 50.81741, lon: -1.24236 },
  { lat: 50.8179, lon: -1.24278 },
  { lat: 50.81763, lon: -1.24393 },
  { lat: 50.81834, lon: -1.24284 },
  { lat: 50.81768, lon: -1.24078 },
  { lat: 50.81795, lon: -1.23806 },
  { lat: 50.81529, lon: -1.23048 },
  { lat: 50.81398, lon: -1.22824 },
  { lat: 50.81303, lon: -1.22341 },
  { lat: 50.81166, lon: -1.22055 },
  { lat: 50.81132, lon: -1.22076 },
  { lat: 50.81156, lon: -1.22005 },
  { lat: 50.81009, lon: -1.21562 },
  { lat: 50.8059, lon: -1.20943 },
  { lat: 50.80061, lon: -1.20392 },
  { lat: 50.79829, lon: -1.2008 },
  { lat: 50.79447, lon: -1.1972 },
  { lat: 50.78981, lon: -1.18987 },
  { lat: 50.78788, lon: -1.18475 },
  { lat: 50.78716, lon: -1.18135 },
  { lat: 50.78563, lon: -1.1711 },
  { lat: 50.78557, lon: -1.16603 },
  { lat: 50.78395, lon: -1.16009 },
  { lat: 50.78122, lon: -1.15396 },
  { lat: 50.77485, lon: -1.14518 },
  { lat: 50.77326, lon: -1.14188 },
  { lat: 50.77332, lon: -1.13929 },
  { lat: 50.77484, lon: -1.13533 },
  { lat: 50.7814, lon: -1.12634 },
  { lat: 50.7896, lon: -1.1119 },
  { lat: 50.79114, lon: -1.11295 },
  { lat: 50.7913, lon: -1.11375 },
  { lat: 50.79014, lon: -1.114 },
  { lat: 50.79005, lon: -1.1149 },
  { lat: 50.79085, lon: -1.11448 },
  { lat: 50.78888, lon: -1.11609 },
  { lat: 50.78885, lon: -1.11473 },
  { lat: 50.78798, lon: -1.11627 },
  { lat: 50.78801, lon: -1.11831 },
  { lat: 50.78876, lon: -1.11931 },
  { lat: 50.78804, lon: -1.12054 },
  { lat: 50.78962, lon: -1.12432 },
  { lat: 50.78807, lon: -1.12665 },
  { lat: 50.78772, lon: -1.12655 },
  { lat: 50.78797, lon: -1.12722 },
  { lat: 50.78755, lon: -1.12681 },
  { lat: 50.78802, lon: -1.12877 },
  { lat: 50.78512, lon: -1.13295 },
  { lat: 50.78421, lon: -1.14004 },
  { lat: 50.78362, lon: -1.14057 },
  { lat: 50.78449, lon: -1.14054 },
  { lat: 50.78413, lon: -1.14345 },
  { lat: 50.78472, lon: -1.14349 },
  { lat: 50.78466, lon: -1.14558 },
  { lat: 50.78527, lon: -1.14544 },
  { lat: 50.78546, lon: -1.14351 },
  { lat: 50.78513, lon: -1.14068 },
  { lat: 50.78463, lon: -1.14042 },
  { lat: 50.78509, lon: -1.14006 },
  { lat: 50.78603, lon: -1.1359 },
  { lat: 50.78594, lon: -1.13367 },
  { lat: 50.7872, lon: -1.13201 },
  { lat: 50.7872, lon: -1.13282 },
  { lat: 50.78798, lon: -1.13196 },
  { lat: 50.78911, lon: -1.13322 },
  { lat: 50.79004, lon: -1.13631 },
  { lat: 50.78951, lon: -1.13933 },
  { lat: 50.79007, lon: -1.13929 },
  { lat: 50.79036, lon: -1.13841 },
  { lat: 50.79038, lon: -1.1346 },
  { lat: 50.78992, lon: -1.1326 },
  { lat: 50.78883, lon: -1.13075 },
  { lat: 50.78947, lon: -1.12968 },
  { lat: 50.78935, lon: -1.12694 },
  { lat: 50.79074, lon: -1.12756 },
  { lat: 50.79119, lon: -1.12849 },
  { lat: 50.7917, lon: -1.12844 },
  { lat: 50.79244, lon: -1.12219 },
  { lat: 50.7921, lon: -1.12284 },
  { lat: 50.79162, lon: -1.1228 },
  { lat: 50.79006, lon: -1.12104 },
  { lat: 50.79223, lon: -1.11775 },
  { lat: 50.79442, lon: -1.11671 },
  { lat: 50.79569, lon: -1.11655 },
  { lat: 50.79606, lon: -1.11698 },
  { lat: 50.79616, lon: -1.11661 },
  { lat: 50.79725, lon: -1.11882 },
  { lat: 50.7971, lon: -1.12085 },
  { lat: 50.79871, lon: -1.12311 },
  { lat: 50.79889, lon: -1.12413 },
  { lat: 50.79935, lon: -1.12394 },
  { lat: 50.79994, lon: -1.12226 },
  { lat: 50.80081, lon: -1.12277 },
  { lat: 50.80084, lon: -1.12186 },
  { lat: 50.80083, lon: -1.12408 },
  { lat: 50.80407, lon: -1.12368 },
  { lat: 50.80291, lon: -1.13078 },
  { lat: 50.8029, lon: -1.13338 },
  { lat: 50.80212, lon: -1.13445 },
  { lat: 50.80224, lon: -1.13708 },
  { lat: 50.80378, lon: -1.1347 },
  { lat: 50.80434, lon: -1.13508 },
  { lat: 50.80454, lon: -1.13606 },
  { lat: 50.80509, lon: -1.13588 },
  { lat: 50.80558, lon: -1.13459 },
  { lat: 50.80538, lon: -1.13381 },
  { lat: 50.80458, lon: -1.13345 },
  { lat: 50.80445, lon: -1.13159 },
  { lat: 50.8062, lon: -1.1238 },
  { lat: 50.80733, lon: -1.12568 },
  { lat: 50.80781, lon: -1.12537 },
  { lat: 50.80795, lon: -1.12606 },
  { lat: 50.80804, lon: -1.12564 },
  { lat: 50.80798, lon: -1.12659 },
  { lat: 50.80886, lon: -1.1282 },
  { lat: 50.81242, lon: -1.13322 },
  { lat: 50.81314, lon: -1.13344 },
  { lat: 50.81342, lon: -1.13484 },
  { lat: 50.81581, lon: -1.13892 },
  { lat: 50.81576, lon: -1.14041 },
  { lat: 50.81692, lon: -1.14195 },
  { lat: 50.82085, lon: -1.14267 },
  { lat: 50.8259, lon: -1.14567 },
  { lat: 50.82596, lon: -1.14768 },
  { lat: 50.82635, lon: -1.14758 },
  { lat: 50.82598, lon: -1.14901 },
  { lat: 50.82645, lon: -1.14813 },
  { lat: 50.82673, lon: -1.14864 },
  { lat: 50.82623, lon: -1.15024 },
  { lat: 50.82595, lon: -1.14936 },
  { lat: 50.82614, lon: -1.15098 },
  { lat: 50.82527, lon: -1.15409 },
  { lat: 50.82575, lon: -1.15371 },
  { lat: 50.82664, lon: -1.1504 },
  { lat: 50.82718, lon: -1.15007 },
  { lat: 50.82801, lon: -1.15092 },
  { lat: 50.82867, lon: -1.15093 },
  { lat: 50.82975, lon: -1.15231 },
  { lat: 50.8303, lon: -1.15194 },
  { lat: 50.83013, lon: -1.15115 },
  { lat: 50.83068, lon: -1.15152 },
  { lat: 50.83056, lon: -1.15026 },
  { lat: 50.83099, lon: -1.15109 },
  { lat: 50.83132, lon: -1.15073 },
  { lat: 50.83117, lon: -1.15012 },
  { lat: 50.83148, lon: -1.15049 },
  { lat: 50.83428, lon: -1.1507 },
  { lat: 50.83584, lon: -1.15259 },
  { lat: 50.83736, lon: -1.15647 },
  { lat: 50.83848, lon: -1.15787 },
  { lat: 50.83895, lon: -1.15772 },
  { lat: 50.83842, lon: -1.158 },
  { lat: 50.83855, lon: -1.1584 },
  { lat: 50.83905, lon: -1.1584 },
  { lat: 50.83908, lon: -1.15888 },
  { lat: 50.83847, lon: -1.15864 },
  { lat: 50.83772, lon: -1.16022 },
  { lat: 50.83645, lon: -1.16537 },
  { lat: 50.8364, lon: -1.16489 },
  { lat: 50.83584, lon: -1.16556 },
  { lat: 50.83575, lon: -1.16505 },
  { lat: 50.8349, lon: -1.16618 },
  { lat: 50.83539, lon: -1.16551 },
  { lat: 50.8363, lon: -1.16584 },
  { lat: 50.83685, lon: -1.16551 },
  { lat: 50.83632, lon: -1.16602 },
  { lat: 50.83636, lon: -1.16763 },
  { lat: 50.83637, lon: -1.16609 },
  { lat: 50.8368, lon: -1.16572 },
  { lat: 50.83689, lon: -1.16622 },
  { lat: 50.83716, lon: -1.16605 },
  { lat: 50.83726, lon: -1.16663 },
  { lat: 50.83689, lon: -1.16643 },
  { lat: 50.83652, lon: -1.1672 },
  { lat: 50.83736, lon: -1.16715 },
  { lat: 50.83678, lon: -1.16741 },
  { lat: 50.83687, lon: -1.16782 },
  { lat: 50.83664, lon: -1.16758 },
  { lat: 50.83678, lon: -1.16815 },
  { lat: 50.83718, lon: -1.16788 },
  { lat: 50.83682, lon: -1.16857 },
  { lat: 50.83723, lon: -1.16799 },
  { lat: 50.83741, lon: -1.16831 },
  { lat: 50.8376, lon: -1.16787 },
  { lat: 50.83707, lon: -1.16771 },
  { lat: 50.83764, lon: -1.16719 },
  { lat: 50.83731, lon: -1.16969 },
  { lat: 50.83675, lon: -1.17007 },
  { lat: 50.83742, lon: -1.16956 },
  { lat: 50.83731, lon: -1.17066 },
  { lat: 50.83789, lon: -1.16781 },
  { lat: 50.83699, lon: -1.16571 },
  { lat: 50.8376, lon: -1.16613 },
  { lat: 50.83793, lon: -1.16769 },
  { lat: 50.83741, lon: -1.17095 },
  { lat: 50.8393, lon: -1.17622 },
  { lat: 50.8374, lon: -1.17944 },
  { lat: 50.83949, lon: -1.17666 },
  { lat: 50.84208, lon: -1.17562 },
  { lat: 50.84358, lon: -1.17625 },
  { lat: 50.84363, lon: -1.17591 },
  { lat: 50.84489, lon: -1.17619 },
  { lat: 50.84646, lon: -1.17847 },
  { lat: 50.84759, lon: -1.17843 },
  { lat: 50.84839, lon: -1.1794 },
  { lat: 50.84866, lon: -1.17921 },
  { lat: 50.8499, lon: -1.17739 },
  { lat: 50.84926, lon: -1.17719 },
  { lat: 50.84992, lon: -1.17626 },
  { lat: 50.84957, lon: -1.16934 },
  { lat: 50.8509, lon: -1.16931 },
  { lat: 50.85192, lon: -1.16828 },
  { lat: 50.8524, lon: -1.16841 },
  { lat: 50.85269, lon: -1.16768 },
  { lat: 50.85244, lon: -1.16645 },
  { lat: 50.85015, lon: -1.16632 },
  { lat: 50.84832, lon: -1.16926 },
  { lat: 50.8476, lon: -1.17131 },
  { lat: 50.84854, lon: -1.17583 },
  { lat: 50.84798, lon: -1.17678 },
  { lat: 50.84734, lon: -1.17666 },
  { lat: 50.84478, lon: -1.17405 },
  { lat: 50.84075, lon: -1.17278 },
  { lat: 50.84, lon: -1.17112 },
  { lat: 50.84024, lon: -1.168 },
  { lat: 50.84143, lon: -1.16317 },
  { lat: 50.84333, lon: -1.16334 },
  { lat: 50.84483, lon: -1.16049 },
  { lat: 50.84442, lon: -1.15715 },
  { lat: 50.84491, lon: -1.15432 },
  { lat: 50.84347, lon: -1.15317 },
  { lat: 50.84296, lon: -1.15458 },
  { lat: 50.84123, lon: -1.15288 },
  { lat: 50.84185, lon: -1.14799 },
  { lat: 50.839, lon: -1.14394 },
  { lat: 50.83858, lon: -1.14142 },
  { lat: 50.8392, lon: -1.13488 },
  { lat: 50.83565, lon: -1.12207 },
  { lat: 50.83609, lon: -1.11294 },
  { lat: 50.83793, lon: -1.11224 },
  { lat: 50.84033, lon: -1.11422 },
  { lat: 50.84016, lon: -1.11464 },
  { lat: 50.84133, lon: -1.11553 },
  { lat: 50.84122, lon: -1.11612 },
  { lat: 50.84191, lon: -1.11568 },
  { lat: 50.84296, lon: -1.11701 },
  { lat: 50.84388, lon: -1.11655 },
  { lat: 50.84391, lon: -1.11453 },
  { lat: 50.84314, lon: -1.11296 },
  { lat: 50.84348, lon: -1.11179 },
  { lat: 50.84365, lon: -1.1123 },
  { lat: 50.84468, lon: -1.1125 },
  { lat: 50.84539, lon: -1.11466 },
  { lat: 50.84511, lon: -1.11537 },
  { lat: 50.84557, lon: -1.11561 },
  { lat: 50.8455, lon: -1.11465 },
  { lat: 50.84689, lon: -1.11334 },
  { lat: 50.84678, lon: -1.10553 },
  { lat: 50.84642, lon: -1.10331 },
  { lat: 50.84581, lon: -1.10249 },
  { lat: 50.83956, lon: -1.10615 },
  { lat: 50.83793, lon: -1.1062 },
  { lat: 50.83431, lon: -1.09899 },
  { lat: 50.83133, lon: -1.09474 },
  { lat: 50.83075, lon: -1.09004 },
  { lat: 50.83156, lon: -1.08841 },
  { lat: 50.8313, lon: -1.08786 },
  { lat: 50.82889, lon: -1.08974 },
  { lat: 50.82846, lon: -1.08872 },
  { lat: 50.82876, lon: -1.0879 },
  { lat: 50.82984, lon: -1.08787 },
  { lat: 50.83124, lon: -1.08668 },
  { lat: 50.83584, lon: -1.08167 },
  { lat: 50.83711, lon: -1.07912 },
  { lat: 50.83737, lon: -1.07676 },
  { lat: 50.83584, lon: -1.061 },
  { lat: 50.83351, lon: -1.05272 },
  { lat: 50.834, lon: -1.04441 },
  { lat: 50.83382, lon: -1.04396 },
  { lat: 50.83235, lon: -1.04442 },
  { lat: 50.83218, lon: -1.04404 },
  { lat: 50.8337, lon: -1.04345 },
  { lat: 50.83546, lon: -1.03629 },
  { lat: 50.83347, lon: -1.03615 },
  { lat: 50.82936, lon: -1.03492 },
  { lat: 50.82866, lon: -1.03134 },
  { lat: 50.82762, lon: -1.03037 },
  { lat: 50.82775, lon: -1.02801 },
  { lat: 50.82687, lon: -1.02767 },
  { lat: 50.82644, lon: -1.0249 },
  { lat: 50.8302, lon: -1.02291 },
  { lat: 50.83166, lon: -1.02452 },
  { lat: 50.83302, lon: -1.02419 },
  { lat: 50.8349, lon: -1.02211 },
  { lat: 50.83629, lon: -1.02241 },
  { lat: 50.83915, lon: -1.02055 },
  { lat: 50.84172, lon: -1.02226 },
  { lat: 50.84254, lon: -1.02167 },
  { lat: 50.84443, lon: -1.01305 },
  { lat: 50.84284, lon: -1.00319 },
  { lat: 50.84491, lon: -1.00145 },
  { lat: 50.84598, lon: -1.00158 },
  { lat: 50.84814, lon: -1.00289 },
  { lat: 50.84492, lon: -1.00086 },
  { lat: 50.84474, lon: -0.99987 },
  { lat: 50.84561, lon: -0.99864 },
  { lat: 50.8438, lon: -1.00083 },
  { lat: 50.84241, lon: -0.99863 },
  { lat: 50.8405, lon: -0.99717 },
  { lat: 50.83884, lon: -0.99361 },
  { lat: 50.83767, lon: -0.98955 },
  { lat: 50.83813, lon: -0.98842 },
  { lat: 50.83771, lon: -0.98875 },
  { lat: 50.83744, lon: -0.98748 },
  { lat: 50.8379, lon: -0.9854 },
  { lat: 50.8379, lon: -0.98619 },
  { lat: 50.83963, lon: -0.98754 },
  { lat: 50.83985, lon: -0.98731 },
  { lat: 50.83837, lon: -0.98622 },
  { lat: 50.83828, lon: -0.98351 },
  { lat: 50.83752, lon: -0.98214 },
  { lat: 50.83495, lon: -0.98124 },
  { lat: 50.83606, lon: -0.98117 },
  { lat: 50.83755, lon: -0.98188 },
  { lat: 50.83709, lon: -0.98113 },
  { lat: 50.83573, lon: -0.98069 },
  { lat: 50.83553, lon: -0.97903 },
  { lat: 50.83705, lon: -0.98034 },
  { lat: 50.83907, lon: -0.97997 },
  { lat: 50.8396, lon: -0.97836 },
  { lat: 50.84141, lon: -0.97709 },
  { lat: 50.84225, lon: -0.97465 },
  { lat: 50.8422, lon: -0.97106 },
  { lat: 50.8405, lon: -0.96587 },
  { lat: 50.84075, lon: -0.96332 },
  { lat: 50.83927, lon: -0.95888 },
  { lat: 50.83978, lon: -0.95597 },
  { lat: 50.84109, lon: -0.95585 },
  { lat: 50.84258, lon: -0.95193 },
  { lat: 50.84322, lon: -0.95156 },
  { lat: 50.84222, lon: -0.94039 },
  { lat: 50.84186, lon: -0.94 },
  { lat: 50.84271, lon: -0.93772 },
  { lat: 50.8439, lon: -0.93723 },
  { lat: 50.84439, lon: -0.93778 },
  { lat: 50.84432, lon: -0.93469 },
  { lat: 50.84381, lon: -0.93275 },
  { lat: 50.84331, lon: -0.93291 },
  { lat: 50.8433, lon: -0.93246 },
  { lat: 50.84371, lon: -0.93202 },
  { lat: 50.84472, lon: -0.93211 },
  { lat: 50.84631, lon: -0.93358 },
  { lat: 50.84622, lon: -0.93258 },
  { lat: 50.84395, lon: -0.93185 },
  { lat: 50.84392, lon: -0.93097 },
  { lat: 50.84355, lon: -0.93093 },
  { lat: 50.84285, lon: -0.93308 },
  { lat: 50.84087, lon: -0.93142 },
  { lat: 50.83057, lon: -0.93876 },
  { lat: 50.83013, lon: -0.9396 },
  { lat: 50.82785, lon: -0.94087 },
  { lat: 50.82764, lon: -0.94142 },
  { lat: 50.82642, lon: -0.94108 },
  { lat: 50.82474, lon: -0.94181 },
  { lat: 50.82438, lon: -0.9424 },
  { lat: 50.82314, lon: -0.93999 },
  { lat: 50.82192, lon: -0.94024 },
  { lat: 50.82128, lon: -0.94168 },
  { lat: 50.81879, lon: -0.93897 },
  { lat: 50.81772, lon: -0.93869 },
  { lat: 50.81688, lon: -0.93978 },
  { lat: 50.81632, lon: -0.94231 },
  { lat: 50.81539, lon: -0.94267 },
  { lat: 50.81419, lon: -0.93442 },
  { lat: 50.81192, lon: -0.92822 },
  { lat: 50.80819, lon: -0.92245 },
  { lat: 50.80607, lon: -0.92095 },
  { lat: 50.80481, lon: -0.91755 },
  { lat: 50.80125, lon: -0.91191 },
  { lat: 50.79916, lon: -0.90953 },
  { lat: 50.79871, lon: -0.90796 },
  { lat: 50.80068, lon: -0.90678 },
  { lat: 50.80197, lon: -0.90726 },
  { lat: 50.80119, lon: -0.90715 },
  { lat: 50.80121, lon: -0.90834 },
  { lat: 50.80075, lon: -0.90806 },
  { lat: 50.8004, lon: -0.90893 },
  { lat: 50.79909, lon: -0.9086 },
  { lat: 50.80094, lon: -0.91142 },
  { lat: 50.80299, lon: -0.91102 },
  { lat: 50.80319, lon: -0.91148 },
  { lat: 50.8024, lon: -0.913 },
  { lat: 50.80306, lon: -0.91415 },
  { lat: 50.80347, lon: -0.91343 },
  { lat: 50.80322, lon: -0.91136 },
  { lat: 50.80356, lon: -0.91047 },
  { lat: 50.80378, lon: -0.91119 },
  { lat: 50.80414, lon: -0.91046 },
  { lat: 50.80616, lon: -0.91079 },
  { lat: 50.80679, lon: -0.91008 },
  { lat: 50.8088, lon: -0.90934 },
  { lat: 50.81381, lon: -0.90939 },
  { lat: 50.81529, lon: -0.90816 },
  { lat: 50.81687, lon: -0.90776 },
  { lat: 50.82129, lon: -0.90974 },
  { lat: 50.82214, lon: -0.90838 },
  { lat: 50.82271, lon: -0.90826 },
  { lat: 50.82353, lon: -0.91013 },
  { lat: 50.82796, lon: -0.91233 },
  { lat: 50.82756, lon: -0.91262 },
  { lat: 50.82786, lon: -0.9178 },
  { lat: 50.8286, lon: -0.91958 },
  { lat: 50.82981, lon: -0.92032 },
  { lat: 50.82993, lon: -0.92129 },
  { lat: 50.83023, lon: -0.92068 },
  { lat: 50.83101, lon: -0.92191 },
  { lat: 50.83119, lon: -0.92271 },
  { lat: 50.83014, lon: -0.92312 },
  { lat: 50.83052, lon: -0.92321 },
  { lat: 50.83029, lon: -0.92383 },
  { lat: 50.83083, lon: -0.92312 },
  { lat: 50.83129, lon: -0.92321 },
  { lat: 50.83168, lon: -0.92417 },
  { lat: 50.83141, lon: -0.92664 },
  { lat: 50.83048, lon: -0.92879 },
  { lat: 50.83106, lon: -0.92941 },
  { lat: 50.83202, lon: -0.92662 },
  { lat: 50.8321, lon: -0.923 },
  { lat: 50.83043, lon: -0.91999 },
  { lat: 50.83103, lon: -0.91819 },
  { lat: 50.82993, lon: -0.9194 },
  { lat: 50.82862, lon: -0.91849 },
  { lat: 50.82809, lon: -0.91241 },
  { lat: 50.83182, lon: -0.91431 },
  { lat: 50.83211, lon: -0.9129 },
  { lat: 50.83402, lon: -0.91373 },
  { lat: 50.83648, lon: -0.91669 },
  { lat: 50.83842, lon: -0.9159 },
  { lat: 50.83993, lon: -0.91296 },
  { lat: 50.83951, lon: -0.90977 },
  { lat: 50.83775, lon: -0.90892 },
  { lat: 50.83834, lon: -0.90477 },
  { lat: 50.83779, lon: -0.89886 },
  { lat: 50.83902, lon: -0.8979 },
  { lat: 50.83829, lon: -0.8938 },
  { lat: 50.83569, lon: -0.89252 },
  { lat: 50.83274, lon: -0.89277 },
  { lat: 50.83193, lon: -0.8968 },
  { lat: 50.83155, lon: -0.89594 },
  { lat: 50.82892, lon: -0.89435 },
  { lat: 50.82856, lon: -0.89498 },
  { lat: 50.82731, lon: -0.89464 },
  { lat: 50.82761, lon: -0.895 },
  { lat: 50.82579, lon: -0.89428 },
  { lat: 50.82454, lon: -0.89253 },
  { lat: 50.82308, lon: -0.89188 },
  { lat: 50.81831, lon: -0.89222 },
  { lat: 50.81661, lon: -0.89059 },
  { lat: 50.81437, lon: -0.88639 },
  { lat: 50.81267, lon: -0.88177 },
  { lat: 50.81148, lon: -0.8767 },
  { lat: 50.81241, lon: -0.87546 },
  { lat: 50.81169, lon: -0.8774 },
  { lat: 50.81196, lon: -0.87843 },
  { lat: 50.81249, lon: -0.87823 },
  { lat: 50.81292, lon: -0.87584 },
  { lat: 50.81451, lon: -0.87527 },
  { lat: 50.81435, lon: -0.87422 },
  { lat: 50.81727, lon: -0.87502 },
  { lat: 50.82335, lon: -0.86982 },
  { lat: 50.82387, lon: -0.87018 },
  { lat: 50.824, lon: -0.87138 },
  { lat: 50.82697, lon: -0.86622 },
  { lat: 50.8291, lon: -0.86738 },
  { lat: 50.8303, lon: -0.86739 },
  { lat: 50.83134, lon: -0.86984 },
  { lat: 50.83121, lon: -0.87266 },
  { lat: 50.83266, lon: -0.87424 },
  { lat: 50.83395, lon: -0.86965 },
  { lat: 50.83634, lon: -0.87086 },
  { lat: 50.83994, lon: -0.86967 },
  { lat: 50.84107, lon: -0.86807 },
  { lat: 50.83851, lon: -0.86641 },
  { lat: 50.83839, lon: -0.86582 },
  { lat: 50.83834, lon: -0.86282 },
  { lat: 50.83999, lon: -0.85944 },
  { lat: 50.83936, lon: -0.85781 },
  { lat: 50.83726, lon: -0.85946 },
  { lat: 50.83601, lon: -0.85913 },
  { lat: 50.83526, lon: -0.85942 },
  { lat: 50.83461, lon: -0.86064 },
  { lat: 50.83023, lon: -0.86135 },
  { lat: 50.82827, lon: -0.86074 },
  { lat: 50.82802, lon: -0.86127 },
  { lat: 50.82796, lon: -0.85911 },
  { lat: 50.82941, lon: -0.85342 },
  { lat: 50.82867, lon: -0.8515 },
  { lat: 50.8275, lon: -0.85115 },
  { lat: 50.82677, lon: -0.85549 },
  { lat: 50.82588, lon: -0.8566 },
  { lat: 50.82358, lon: -0.85792 },
  { lat: 50.82332, lon: -0.86287 },
  { lat: 50.82169, lon: -0.86501 },
  { lat: 50.8202, lon: -0.86588 },
  { lat: 50.81791, lon: -0.86974 },
  { lat: 50.8167, lon: -0.8699 },
  { lat: 50.81465, lon: -0.86852 },
  { lat: 50.81404, lon: -0.869 },
  { lat: 50.81327, lon: -0.86857 },
  { lat: 50.81188, lon: -0.86513 },
  { lat: 50.81235, lon: -0.8643 },
  { lat: 50.81234, lon: -0.8625 },
  { lat: 50.81084, lon: -0.85809 },
  { lat: 50.81159, lon: -0.85645 },
  { lat: 50.81237, lon: -0.85652 },
  { lat: 50.8117, lon: -0.85479 },
  { lat: 50.81184, lon: -0.85344 },
  { lat: 50.81245, lon: -0.85279 },
  { lat: 50.81111, lon: -0.85157 },
  { lat: 50.81087, lon: -0.85035 },
];

export const SOLENT_ISLANDS: ReadonlyArray<ReadonlyArray<LatLon>> = [
  [
    { lat: 50.70592, lon: -1.41243 },
    { lat: 50.70473, lon: -1.41287 },
    { lat: 50.70561, lon: -1.41261 },
    { lat: 50.70792, lon: -1.41401 },
    { lat: 50.71011, lon: -1.41445 },
    { lat: 50.71184, lon: -1.41424 },
    { lat: 50.71238, lon: -1.41356 },
    { lat: 50.71267, lon: -1.41613 },
    { lat: 50.71024, lon: -1.4167 },
    { lat: 50.71194, lon: -1.41765 },
    { lat: 50.71206, lon: -1.41822 },
    { lat: 50.71112, lon: -1.42176 },
    { lat: 50.70919, lon: -1.42509 },
    { lat: 50.70794, lon: -1.42481 },
    { lat: 50.70667, lon: -1.42667 },
    { lat: 50.70521, lon: -1.42616 },
    { lat: 50.7048, lon: -1.42921 },
    { lat: 50.70398, lon: -1.42971 },
    { lat: 50.70477, lon: -1.43003 },
    { lat: 50.70415, lon: -1.4347 },
    { lat: 50.70571, lon: -1.427 },
    { lat: 50.70692, lon: -1.42724 },
    { lat: 50.70836, lon: -1.42642 },
    { lat: 50.70883, lon: -1.42726 },
    { lat: 50.70866, lon: -1.42884 },
    { lat: 50.70931, lon: -1.42679 },
    { lat: 50.71026, lon: -1.42572 },
    { lat: 50.71073, lon: -1.42759 },
    { lat: 50.71106, lon: -1.42423 },
    { lat: 50.71236, lon: -1.42257 },
    { lat: 50.71275, lon: -1.4196 },
    { lat: 50.7139, lon: -1.41738 },
    { lat: 50.71693, lon: -1.41573 },
    { lat: 50.71752, lon: -1.41411 },
    { lat: 50.71816, lon: -1.41346 },
    { lat: 50.71899, lon: -1.41355 },
    { lat: 50.71953, lon: -1.41284 },
    { lat: 50.71958, lon: -1.41544 },
    { lat: 50.71877, lon: -1.41824 },
    { lat: 50.72023, lon: -1.41815 },
    { lat: 50.72096, lon: -1.41385 },
    { lat: 50.72202, lon: -1.41447 },
    { lat: 50.72277, lon: -1.41566 },
    { lat: 50.72442, lon: -1.42283 },
    { lat: 50.72501, lon: -1.42152 },
    { lat: 50.72446, lon: -1.4162 },
    { lat: 50.72303, lon: -1.41216 },
    { lat: 50.7249, lon: -1.41551 },
    { lat: 50.72428, lon: -1.412 },
    { lat: 50.72353, lon: -1.41164 },
    { lat: 50.72401, lon: -1.41137 },
    { lat: 50.72432, lon: -1.41181 },
    { lat: 50.72676, lon: -1.42539 },
    { lat: 50.72203, lon: -1.44203 },
    { lat: 50.71972, lon: -1.446 },
    { lat: 50.7191, lon: -1.44941 },
    { lat: 50.7182, lon: -1.45062 },
    { lat: 50.71617, lon: -1.45706 },
    { lat: 50.71428, lon: -1.45966 },
    { lat: 50.70954, lon: -1.46963 },
    { lat: 50.70982, lon: -1.47233 },
    { lat: 50.70888, lon: -1.47462 },
    { lat: 50.70849, lon: -1.47936 },
    { lat: 50.7067, lon: -1.48684 },
    { lat: 50.70673, lon: -1.49983 },
    { lat: 50.70708, lon: -1.50124 },
    { lat: 50.70578, lon: -1.50857 },
    { lat: 50.707, lon: -1.51559 },
    { lat: 50.70716, lon: -1.52202 },
    { lat: 50.70425, lon: -1.52676 },
    { lat: 50.70331, lon: -1.52983 },
    { lat: 50.70067, lon: -1.53341 },
    { lat: 50.70071, lon: -1.53452 },
    { lat: 50.70041, lon: -1.53478 },
    { lat: 50.7, lon: -1.53429 },
    { lat: 50.69758, lon: -1.53403 },
    { lat: 50.69668, lon: -1.53337 },
    { lat: 50.69291, lon: -1.53432 },
    { lat: 50.68954, lon: -1.53839 },
    { lat: 50.68891, lon: -1.54168 },
    { lat: 50.68784, lon: -1.54294 },
    { lat: 50.68204, lon: -1.54481 },
    { lat: 50.67835, lon: -1.54799 },
    { lat: 50.67741, lon: -1.54985 },
    { lat: 50.67557, lon: -1.56347 },
    { lat: 50.67398, lon: -1.56711 },
    { lat: 50.67358, lon: -1.56947 },
    { lat: 50.67259, lon: -1.57018 },
    { lat: 50.66949, lon: -1.56938 },
    { lat: 50.66907, lon: -1.56967 },
    { lat: 50.66857, lon: -1.56908 },
    { lat: 50.66708, lon: -1.56869 },
    { lat: 50.66576, lon: -1.56906 },
    { lat: 50.66543, lon: -1.56965 },
    { lat: 50.66383, lon: -1.57626 },
    { lat: 50.66309, lon: -1.58658 },
    { lat: 50.66123, lon: -1.5793 },
    { lat: 50.6601, lon: -1.57929 },
    { lat: 50.66046, lon: -1.5741 },
    { lat: 50.66093, lon: -1.56932 },
    { lat: 50.66306, lon: -1.56149 },
    { lat: 50.66352, lon: -1.54919 },
    { lat: 50.66572, lon: -1.53959 },
    { lat: 50.667, lon: -1.5314 },
    { lat: 50.66842, lon: -1.51689 },
    { lat: 50.66815, lon: -1.51434 },
    { lat: 50.66839, lon: -1.51348 },
    { lat: 50.66894, lon: -1.51363 },
    { lat: 50.66941, lon: -1.51296 },
    { lat: 50.67009, lon: -1.51105 },
    { lat: 50.66968, lon: -1.50842 },
    { lat: 50.66882, lon: -1.50733 },
    { lat: 50.66834, lon: -1.50554 },
    { lat: 50.66827, lon: -1.49301 },
    { lat: 50.66648, lon: -1.48334 },
    { lat: 50.65991, lon: -1.47285 },
    { lat: 50.65309, lon: -1.4649 },
    { lat: 50.65056, lon: -1.45739 },
    { lat: 50.64698, lon: -1.45338 },
    { lat: 50.64374, lon: -1.44781 },
    { lat: 50.64018, lon: -1.43248 },
    { lat: 50.63828, lon: -1.42724 },
    { lat: 50.63462, lon: -1.4096 },
    { lat: 50.62924, lon: -1.3975 },
    { lat: 50.62733, lon: -1.38954 },
    { lat: 50.61665, lon: -1.37075 },
    { lat: 50.61346, lon: -1.36603 },
    { lat: 50.60981, lon: -1.36198 },
    { lat: 50.60866, lon: -1.35485 },
    { lat: 50.60795, lon: -1.35463 },
    { lat: 50.60448, lon: -1.34556 },
    { lat: 50.60068, lon: -1.33733 },
    { lat: 50.58922, lon: -1.31802 },
    { lat: 50.58077, lon: -1.30917 },
    { lat: 50.57734, lon: -1.30784 },
    { lat: 50.57684, lon: -1.30513 },
    { lat: 50.5755, lon: -1.30287 },
    { lat: 50.57478, lon: -1.29909 },
    { lat: 50.57543, lon: -1.29107 },
    { lat: 50.5765, lon: -1.28787 },
    { lat: 50.57751, lon: -1.28671 },
    { lat: 50.57706, lon: -1.28073 },
    { lat: 50.57858, lon: -1.27801 },
    { lat: 50.57953, lon: -1.27258 },
    { lat: 50.57944, lon: -1.26803 },
    { lat: 50.58013, lon: -1.26312 },
    { lat: 50.57934, lon: -1.25983 },
    { lat: 50.57993, lon: -1.25538 },
    { lat: 50.58108, lon: -1.25193 },
    { lat: 50.58083, lon: -1.24997 },
    { lat: 50.58233, lon: -1.24699 },
    { lat: 50.58218, lon: -1.24448 },
    { lat: 50.58279, lon: -1.24202 },
    { lat: 50.58434, lon: -1.24 },
    { lat: 50.5855, lon: -1.23612 },
    { lat: 50.58623, lon: -1.23515 },
    { lat: 50.58617, lon: -1.23305 },
    { lat: 50.58685, lon: -1.23194 },
    { lat: 50.58712, lon: -1.22888 },
    { lat: 50.58867, lon: -1.22424 },
    { lat: 50.58851, lon: -1.22216 },
    { lat: 50.5894, lon: -1.22109 },
    { lat: 50.58944, lon: -1.21976 },
    { lat: 50.59114, lon: -1.21577 },
    { lat: 50.59146, lon: -1.21325 },
    { lat: 50.59305, lon: -1.20958 },
    { lat: 50.59298, lon: -1.20625 },
    { lat: 50.59215, lon: -1.2054 },
    { lat: 50.59195, lon: -1.2042 },
    { lat: 50.59228, lon: -1.20515 },
    { lat: 50.59305, lon: -1.20532 },
    { lat: 50.59302, lon: -1.20439 },
    { lat: 50.59252, lon: -1.20434 },
    { lat: 50.59294, lon: -1.2041 },
    { lat: 50.5929, lon: -1.20153 },
    { lat: 50.59378, lon: -1.19796 },
    { lat: 50.59511, lon: -1.19591 },
    { lat: 50.59671, lon: -1.18727 },
    { lat: 50.59725, lon: -1.18534 },
    { lat: 50.59816, lon: -1.18413 },
    { lat: 50.59794, lon: -1.18354 },
    { lat: 50.59841, lon: -1.18381 },
    { lat: 50.59881, lon: -1.18165 },
    { lat: 50.59919, lon: -1.18187 },
    { lat: 50.59958, lon: -1.18047 },
    { lat: 50.60185, lon: -1.17905 },
    { lat: 50.60313, lon: -1.17752 },
    { lat: 50.60659, lon: -1.17527 },
    { lat: 50.60849, lon: -1.17559 },
    { lat: 50.61065, lon: -1.17716 },
    { lat: 50.61554, lon: -1.17245 },
    { lat: 50.61869, lon: -1.17319 },
    { lat: 50.62109, lon: -1.17472 },
    { lat: 50.6243, lon: -1.17435 },
    { lat: 50.6306, lon: -1.17149 },
    { lat: 50.63337, lon: -1.16916 },
    { lat: 50.63418, lon: -1.17 },
    { lat: 50.63597, lon: -1.1688 },
    { lat: 50.63609, lon: -1.16924 },
    { lat: 50.63842, lon: -1.16899 },
    { lat: 50.64157, lon: -1.16799 },
    { lat: 50.64658, lon: -1.16362 },
    { lat: 50.64961, lon: -1.16013 },
    { lat: 50.65633, lon: -1.14813 },
    { lat: 50.66065, lon: -1.13757 },
    { lat: 50.66266, lon: -1.13123 },
    { lat: 50.66465, lon: -1.12125 },
    { lat: 50.66566, lon: -1.11299 },
    { lat: 50.66498, lon: -1.10327 },
    { lat: 50.66523, lon: -1.09794 },
    { lat: 50.66562, lon: -1.09806 },
    { lat: 50.66721, lon: -1.0953 },
    { lat: 50.66851, lon: -1.09753 },
    { lat: 50.66993, lon: -1.09708 },
    { lat: 50.67198, lon: -1.0947 },
    { lat: 50.67363, lon: -1.09118 },
    { lat: 50.67452, lon: -1.08772 },
    { lat: 50.67587, lon: -1.08616 },
    { lat: 50.67709, lon: -1.0857 },
    { lat: 50.68059, lon: -1.0771 },
    { lat: 50.68141, lon: -1.07346 },
    { lat: 50.6837, lon: -1.07011 },
    { lat: 50.68468, lon: -1.06986 },
    { lat: 50.68656, lon: -1.06992 },
    { lat: 50.68804, lon: -1.07104 },
    { lat: 50.69116, lon: -1.07568 },
    { lat: 50.69445, lon: -1.08241 },
    { lat: 50.69583, lon: -1.09368 },
    { lat: 50.69489, lon: -1.09468 },
    { lat: 50.69397, lon: -1.09316 },
    { lat: 50.69295, lon: -1.09368 },
    { lat: 50.69105, lon: -1.09631 },
    { lat: 50.69038, lon: -1.0983 },
    { lat: 50.6924, lon: -1.10236 },
    { lat: 50.69309, lon: -1.10682 },
    { lat: 50.69374, lon: -1.10825 },
    { lat: 50.69346, lon: -1.10915 },
    { lat: 50.69393, lon: -1.10728 },
    { lat: 50.69451, lon: -1.10743 },
    { lat: 50.69451, lon: -1.10645 },
    { lat: 50.69725, lon: -1.10244 },
    { lat: 50.6966, lon: -1.10103 },
    { lat: 50.69544, lon: -1.10074 },
    { lat: 50.69424, lon: -1.0962 },
    { lat: 50.69673, lon: -1.09802 },
    { lat: 50.70088, lon: -1.09907 },
    { lat: 50.70148, lon: -1.09914 },
    { lat: 50.70298, lon: -1.09814 },
    { lat: 50.70541, lon: -1.09819 },
    { lat: 50.7061, lon: -1.0978 },
    { lat: 50.70647, lon: -1.10053 },
    { lat: 50.70731, lon: -1.10143 },
    { lat: 50.71263, lon: -1.10315 },
    { lat: 50.71306, lon: -1.10517 },
    { lat: 50.71398, lon: -1.10615 },
    { lat: 50.71724, lon: -1.107 },
    { lat: 50.71812, lon: -1.10799 },
    { lat: 50.71997, lon: -1.10823 },
    { lat: 50.72153, lon: -1.10965 },
    { lat: 50.72203, lon: -1.11483 },
    { lat: 50.72322, lon: -1.11831 },
    { lat: 50.72323, lon: -1.12023 },
    { lat: 50.72535, lon: -1.12719 },
    { lat: 50.7268, lon: -1.13041 },
    { lat: 50.72651, lon: -1.13423 },
    { lat: 50.72697, lon: -1.13802 },
    { lat: 50.72825, lon: -1.14235 },
    { lat: 50.73115, lon: -1.14853 },
    { lat: 50.73163, lon: -1.15315 },
    { lat: 50.73298, lon: -1.15352 },
    { lat: 50.73321, lon: -1.15488 },
    { lat: 50.73289, lon: -1.15357 },
    { lat: 50.73163, lon: -1.15347 },
    { lat: 50.73206, lon: -1.15518 },
    { lat: 50.73293, lon: -1.15526 },
    { lat: 50.73355, lon: -1.15746 },
    { lat: 50.73302, lon: -1.15795 },
    { lat: 50.73299, lon: -1.15903 },
    { lat: 50.7335, lon: -1.16274 },
    { lat: 50.73276, lon: -1.16428 },
    { lat: 50.73412, lon: -1.17879 },
    { lat: 50.73296, lon: -1.18379 },
    { lat: 50.73344, lon: -1.18607 },
    { lat: 50.73272, lon: -1.19226 },
    { lat: 50.7349, lon: -1.20798 },
    { lat: 50.73501, lon: -1.21088 },
    { lat: 50.73397, lon: -1.21261 },
    { lat: 50.73387, lon: -1.2159 },
    { lat: 50.73492, lon: -1.21742 },
    { lat: 50.7343, lon: -1.21644 },
    { lat: 50.7336, lon: -1.21756 },
    { lat: 50.73229, lon: -1.21727 },
    { lat: 50.73139, lon: -1.21772 },
    { lat: 50.72995, lon: -1.21974 },
    { lat: 50.72904, lon: -1.21949 },
    { lat: 50.72983, lon: -1.22067 },
    { lat: 50.72924, lon: -1.22169 },
    { lat: 50.72678, lon: -1.22477 },
    { lat: 50.72519, lon: -1.22459 },
    { lat: 50.72479, lon: -1.22531 },
    { lat: 50.72454, lon: -1.22512 },
    { lat: 50.72463, lon: -1.22567 },
    { lat: 50.72532, lon: -1.2265 },
    { lat: 50.72645, lon: -1.22653 },
    { lat: 50.72683, lon: -1.22724 },
    { lat: 50.72673, lon: -1.22675 },
    { lat: 50.72737, lon: -1.2268 },
    { lat: 50.72995, lon: -1.22323 },
    { lat: 50.73073, lon: -1.22264 },
    { lat: 50.73136, lon: -1.22349 },
    { lat: 50.73113, lon: -1.22226 },
    { lat: 50.73186, lon: -1.22041 },
    { lat: 50.73499, lon: -1.21934 },
    { lat: 50.73606, lon: -1.21675 },
    { lat: 50.73604, lon: -1.21539 },
    { lat: 50.73567, lon: -1.21644 },
    { lat: 50.73557, lon: -1.21584 },
    { lat: 50.73671, lon: -1.21416 },
    { lat: 50.73761, lon: -1.21366 },
    { lat: 50.73803, lon: -1.21393 },
    { lat: 50.7392, lon: -1.22119 },
    { lat: 50.74286, lon: -1.23079 },
    { lat: 50.7432, lon: -1.2353 },
    { lat: 50.74246, lon: -1.23888 },
    { lat: 50.74319, lon: -1.23999 },
    { lat: 50.74592, lon: -1.24171 },
    { lat: 50.74946, lon: -1.24617 },
    { lat: 50.75176, lon: -1.24768 },
    { lat: 50.75251, lon: -1.24911 },
    { lat: 50.7541, lon: -1.25565 },
    { lat: 50.76028, lon: -1.26081 },
    { lat: 50.76165, lon: -1.26432 },
    { lat: 50.76506, lon: -1.27024 },
    { lat: 50.76631, lon: -1.27608 },
    { lat: 50.76618, lon: -1.27835 },
    { lat: 50.76296, lon: -1.28829 },
    { lat: 50.76466, lon: -1.29188 },
    { lat: 50.76295, lon: -1.28831 },
    { lat: 50.76179, lon: -1.29611 },
    { lat: 50.76223, lon: -1.29635 },
    { lat: 50.76264, lon: -1.29578 },
    { lat: 50.76202, lon: -1.29492 },
    { lat: 50.76268, lon: -1.29578 },
    { lat: 50.76225, lon: -1.297 },
    { lat: 50.76267, lon: -1.29652 },
    { lat: 50.76294, lon: -1.29717 },
    { lat: 50.76302, lon: -1.29683 },
    { lat: 50.76339, lon: -1.29734 },
    { lat: 50.76381, lon: -1.29708 },
    { lat: 50.76421, lon: -1.29814 },
    { lat: 50.76476, lon: -1.29778 },
    { lat: 50.7664, lon: -1.30062 },
    { lat: 50.7669, lon: -1.3003 },
    { lat: 50.76668, lon: -1.29963 },
    { lat: 50.76698, lon: -1.30003 },
    { lat: 50.76669, lon: -1.3015 },
    { lat: 50.76733, lon: -1.31387 },
    { lat: 50.7657, lon: -1.31946 },
    { lat: 50.7635, lon: -1.32311 },
    { lat: 50.76072, lon: -1.32464 },
    { lat: 50.75807, lon: -1.32782 },
    { lat: 50.75624, lon: -1.33328 },
    { lat: 50.75565, lon: -1.33347 },
    { lat: 50.75632, lon: -1.3337 },
    { lat: 50.75558, lon: -1.33455 },
    { lat: 50.75529, lon: -1.33773 },
    { lat: 50.75087, lon: -1.34479 },
    { lat: 50.74767, lon: -1.34519 },
    { lat: 50.74341, lon: -1.34718 },
    { lat: 50.7418, lon: -1.34904 },
    { lat: 50.74049, lon: -1.35205 },
    { lat: 50.73918, lon: -1.35333 },
    { lat: 50.738, lon: -1.35827 },
    { lat: 50.73784, lon: -1.36387 },
    { lat: 50.73551, lon: -1.37185 },
    { lat: 50.7341, lon: -1.37926 },
    { lat: 50.73251, lon: -1.382 },
    { lat: 50.73162, lon: -1.38944 },
    { lat: 50.73033, lon: -1.39207 },
    { lat: 50.72864, lon: -1.39772 },
    { lat: 50.72792, lon: -1.40249 },
    { lat: 50.72669, lon: -1.40414 },
    { lat: 50.72535, lon: -1.40901 },
    { lat: 50.72423, lon: -1.4104 },
    { lat: 50.72388, lon: -1.40958 },
    { lat: 50.72527, lon: -1.40896 },
    { lat: 50.72751, lon: -1.40164 },
    { lat: 50.72663, lon: -1.39955 },
    { lat: 50.72658, lon: -1.39555 },
    { lat: 50.72563, lon: -1.39597 },
    { lat: 50.72499, lon: -1.39512 },
    { lat: 50.72389, lon: -1.39544 },
    { lat: 50.72386, lon: -1.39404 },
    { lat: 50.7234, lon: -1.39341 },
    { lat: 50.72368, lon: -1.38966 },
    { lat: 50.72265, lon: -1.38785 },
    { lat: 50.7226, lon: -1.3846 },
    { lat: 50.72218, lon: -1.38662 },
    { lat: 50.72184, lon: -1.38668 },
    { lat: 50.72201, lon: -1.38831 },
    { lat: 50.72154, lon: -1.38962 },
    { lat: 50.72008, lon: -1.38938 },
    { lat: 50.71967, lon: -1.38879 },
    { lat: 50.71972, lon: -1.38996 },
    { lat: 50.71872, lon: -1.39245 },
    { lat: 50.71834, lon: -1.39285 },
    { lat: 50.71783, lon: -1.3924 },
    { lat: 50.71702, lon: -1.38732 },
    { lat: 50.71721, lon: -1.38103 },
    { lat: 50.71857, lon: -1.37869 },
    { lat: 50.71911, lon: -1.37342 },
    { lat: 50.71745, lon: -1.37925 },
    { lat: 50.71532, lon: -1.37817 },
    { lat: 50.71524, lon: -1.37745 },
    { lat: 50.71496, lon: -1.37789 },
    { lat: 50.71343, lon: -1.37678 },
    { lat: 50.71254, lon: -1.37745 },
    { lat: 50.71092, lon: -1.37688 },
    { lat: 50.71142, lon: -1.3775 },
    { lat: 50.71397, lon: -1.37815 },
    { lat: 50.71545, lon: -1.37925 },
    { lat: 50.716, lon: -1.3804 },
    { lat: 50.71592, lon: -1.38197 },
    { lat: 50.71526, lon: -1.3825 },
    { lat: 50.71566, lon: -1.38355 },
    { lat: 50.71503, lon: -1.38446 },
    { lat: 50.71532, lon: -1.38656 },
    { lat: 50.71485, lon: -1.38735 },
    { lat: 50.71564, lon: -1.38909 },
    { lat: 50.71558, lon: -1.39327 },
    { lat: 50.71675, lon: -1.39623 },
    { lat: 50.71637, lon: -1.39994 },
    { lat: 50.71686, lon: -1.40512 },
    { lat: 50.7159, lon: -1.40926 },
    { lat: 50.71659, lon: -1.40977 },
    { lat: 50.71795, lon: -1.40772 },
    { lat: 50.7191, lon: -1.40804 },
    { lat: 50.71846, lon: -1.40791 },
    { lat: 50.71785, lon: -1.40935 },
    { lat: 50.7171, lon: -1.40897 },
    { lat: 50.71661, lon: -1.40985 },
    { lat: 50.71512, lon: -1.40918 },
    { lat: 50.71457, lon: -1.40717 },
    { lat: 50.71138, lon: -1.40168 },
    { lat: 50.7108, lon: -1.39982 },
    { lat: 50.71108, lon: -1.40187 },
    { lat: 50.70974, lon: -1.40255 },
    { lat: 50.7108, lon: -1.40283 },
    { lat: 50.71199, lon: -1.40432 },
    { lat: 50.7142, lon: -1.4113 },
    { lat: 50.71403, lon: -1.41185 },
    { lat: 50.71196, lon: -1.41177 },
    { lat: 50.71049, lon: -1.40984 },
    { lat: 50.71048, lon: -1.40843 },
    { lat: 50.70954, lon: -1.40697 },
    { lat: 50.70908, lon: -1.40745 },
    { lat: 50.70976, lon: -1.40784 },
    { lat: 50.71044, lon: -1.41296 },
    { lat: 50.70817, lon: -1.41316 },
    { lat: 50.70767, lon: -1.41263 },
    { lat: 50.70592, lon: -1.41243 },
  ],
  [
    { lat: 50.83021, lon: -0.9561 },
    { lat: 50.83079, lon: -0.95726 },
    { lat: 50.83132, lon: -0.95728 },
    { lat: 50.83146, lon: -0.95899 },
    { lat: 50.83038, lon: -0.95992 },
    { lat: 50.8306, lon: -0.96119 },
    { lat: 50.83154, lon: -0.96229 },
    { lat: 50.83097, lon: -0.96197 },
    { lat: 50.8309, lon: -0.96464 },
    { lat: 50.83141, lon: -0.96384 },
    { lat: 50.83318, lon: -0.96366 },
    { lat: 50.83188, lon: -0.96244 },
    { lat: 50.83228, lon: -0.96233 },
    { lat: 50.83379, lon: -0.96453 },
    { lat: 50.83337, lon: -0.96381 },
    { lat: 50.83151, lon: -0.96421 },
    { lat: 50.83094, lon: -0.9665 },
    { lat: 50.83053, lon: -0.9667 },
    { lat: 50.83066, lon: -0.96848 },
    { lat: 50.83115, lon: -0.96878 },
    { lat: 50.83081, lon: -0.97032 },
    { lat: 50.83173, lon: -0.96852 },
    { lat: 50.83165, lon: -0.96995 },
    { lat: 50.83229, lon: -0.97014 },
    { lat: 50.83199, lon: -0.96802 },
    { lat: 50.83445, lon: -0.96719 },
    { lat: 50.83403, lon: -0.9652 },
    { lat: 50.83472, lon: -0.96686 },
    { lat: 50.83481, lon: -0.96874 },
    { lat: 50.83452, lon: -0.97035 },
    { lat: 50.83391, lon: -0.97116 },
    { lat: 50.83269, lon: -0.97136 },
    { lat: 50.83214, lon: -0.97341 },
    { lat: 50.83184, lon: -0.97721 },
    { lat: 50.83309, lon: -0.97761 },
    { lat: 50.83311, lon: -0.97802 },
    { lat: 50.83152, lon: -0.97797 },
    { lat: 50.83003, lon: -0.98096 },
    { lat: 50.83065, lon: -0.98226 },
    { lat: 50.83203, lon: -0.98131 },
    { lat: 50.83213, lon: -0.98171 },
    { lat: 50.83057, lon: -0.98265 },
    { lat: 50.83002, lon: -0.98357 },
    { lat: 50.82838, lon: -0.98846 },
    { lat: 50.8265, lon: -0.99056 },
    { lat: 50.82483, lon: -0.99084 },
    { lat: 50.823, lon: -0.98701 },
    { lat: 50.82382, lon: -0.98766 },
    { lat: 50.82376, lon: -0.98615 },
    { lat: 50.82282, lon: -0.98457 },
    { lat: 50.82123, lon: -0.98335 },
    { lat: 50.8191, lon: -0.98429 },
    { lat: 50.81862, lon: -0.98547 },
    { lat: 50.8197, lon: -0.98538 },
    { lat: 50.82028, lon: -0.98439 },
    { lat: 50.81976, lon: -0.9858 },
    { lat: 50.81322, lon: -0.98608 },
    { lat: 50.81118, lon: -0.9888 },
    { lat: 50.80377, lon: -0.98934 },
    { lat: 50.80157, lon: -0.99107 },
    { lat: 50.80041, lon: -0.99295 },
    { lat: 50.79828, lon: -0.99456 },
    { lat: 50.79711, lon: -0.99628 },
    { lat: 50.79458, lon: -1.00131 },
    { lat: 50.79407, lon: -1.0038 },
    { lat: 50.79347, lon: -1.00906 },
    { lat: 50.79434, lon: -1.01553 },
    { lat: 50.79518, lon: -1.01737 },
    { lat: 50.79443, lon: -1.01829 },
    { lat: 50.79314, lon: -1.01668 },
    { lat: 50.79252, lon: -1.01708 },
    { lat: 50.79372, lon: -1.01777 },
    { lat: 50.79237, lon: -1.01749 },
    { lat: 50.79299, lon: -1.02073 },
    { lat: 50.79376, lon: -1.02195 },
    { lat: 50.79557, lon: -1.02115 },
    { lat: 50.79571, lon: -1.01969 },
    { lat: 50.79577, lon: -1.02546 },
    { lat: 50.79355, lon: -1.02545 },
    { lat: 50.79113, lon: -1.02417 },
    { lat: 50.78831, lon: -1.02369 },
    { lat: 50.78467, lon: -1.02065 },
    { lat: 50.78426, lon: -1.01959 },
    { lat: 50.78555, lon: -1.00428 },
    { lat: 50.78456, lon: -1.00113 },
    { lat: 50.78229, lon: -0.97545 },
    { lat: 50.77686, lon: -0.94712 },
    { lat: 50.7769, lon: -0.93906 },
    { lat: 50.77748, lon: -0.93763 },
    { lat: 50.77932, lon: -0.9359 },
    { lat: 50.78383, lon: -0.93624 },
    { lat: 50.78594, lon: -0.9359 },
    { lat: 50.78684, lon: -0.9365 },
    { lat: 50.78742, lon: -0.93779 },
    { lat: 50.78755, lon: -0.93907 },
    { lat: 50.78704, lon: -0.94044 },
    { lat: 50.78737, lon: -0.94149 },
    { lat: 50.78674, lon: -0.94114 },
    { lat: 50.7862, lon: -0.93895 },
    { lat: 50.78487, lon: -0.93688 },
    { lat: 50.78288, lon: -0.93685 },
    { lat: 50.78249, lon: -0.93737 },
    { lat: 50.78243, lon: -0.93821 },
    { lat: 50.78288, lon: -0.93785 },
    { lat: 50.78437, lon: -0.93931 },
    { lat: 50.78516, lon: -0.94123 },
    { lat: 50.78589, lon: -0.94132 },
    { lat: 50.78671, lon: -0.94309 },
    { lat: 50.78499, lon: -0.94208 },
    { lat: 50.78481, lon: -0.94249 },
    { lat: 50.78421, lon: -0.94829 },
    { lat: 50.7836, lon: -0.94837 },
    { lat: 50.78297, lon: -0.95006 },
    { lat: 50.78302, lon: -0.95386 },
    { lat: 50.78187, lon: -0.95554 },
    { lat: 50.78128, lon: -0.95832 },
    { lat: 50.78219, lon: -0.96139 },
    { lat: 50.78202, lon: -0.95909 },
    { lat: 50.78285, lon: -0.95594 },
    { lat: 50.78375, lon: -0.95498 },
    { lat: 50.78423, lon: -0.95116 },
    { lat: 50.78586, lon: -0.95169 },
    { lat: 50.78585, lon: -0.9526 },
    { lat: 50.78693, lon: -0.95138 },
    { lat: 50.78751, lon: -0.9522 },
    { lat: 50.78983, lon: -0.95758 },
    { lat: 50.78916, lon: -0.95975 },
    { lat: 50.78938, lon: -0.9604 },
    { lat: 50.78833, lon: -0.96243 },
    { lat: 50.78835, lon: -0.96598 },
    { lat: 50.78723, lon: -0.96727 },
    { lat: 50.78921, lon: -0.96713 },
    { lat: 50.79016, lon: -0.96792 },
    { lat: 50.78932, lon: -0.96622 },
    { lat: 50.78945, lon: -0.9629 },
    { lat: 50.79084, lon: -0.95978 },
    { lat: 50.79304, lon: -0.95863 },
    { lat: 50.79374, lon: -0.95541 },
    { lat: 50.79453, lon: -0.9553 },
    { lat: 50.7953, lon: -0.95654 },
    { lat: 50.79717, lon: -0.95646 },
    { lat: 50.79934, lon: -0.95704 },
    { lat: 50.79978, lon: -0.95614 },
    { lat: 50.7997, lon: -0.95462 },
    { lat: 50.80104, lon: -0.95272 },
    { lat: 50.80298, lon: -0.95617 },
    { lat: 50.80427, lon: -0.95726 },
    { lat: 50.80471, lon: -0.95869 },
    { lat: 50.80448, lon: -0.96005 },
    { lat: 50.8035, lon: -0.96125 },
    { lat: 50.80338, lon: -0.96474 },
    { lat: 50.80263, lon: -0.9657 },
    { lat: 50.80267, lon: -0.96894 },
    { lat: 50.80451, lon: -0.9693 },
    { lat: 50.8066, lon: -0.97244 },
    { lat: 50.80681, lon: -0.97196 },
    { lat: 50.80664, lon: -0.97257 },
    { lat: 50.80712, lon: -0.97316 },
    { lat: 50.80756, lon: -0.97264 },
    { lat: 50.807, lon: -0.97188 },
    { lat: 50.80892, lon: -0.97342 },
    { lat: 50.80887, lon: -0.97232 },
    { lat: 50.80722, lon: -0.97101 },
    { lat: 50.8065, lon: -0.9694 },
    { lat: 50.8063, lon: -0.96606 },
    { lat: 50.80738, lon: -0.96312 },
    { lat: 50.80954, lon: -0.96392 },
    { lat: 50.80943, lon: -0.96651 },
    { lat: 50.81057, lon: -0.9709 },
    { lat: 50.81134, lon: -0.96102 },
    { lat: 50.80943, lon: -0.95868 },
    { lat: 50.8096, lon: -0.95756 },
    { lat: 50.813, lon: -0.95635 },
    { lat: 50.81554, lon: -0.95765 },
    { lat: 50.81631, lon: -0.95711 },
    { lat: 50.81654, lon: -0.95472 },
    { lat: 50.81699, lon: -0.9546 },
    { lat: 50.81761, lon: -0.95542 },
    { lat: 50.8187, lon: -0.95451 },
    { lat: 50.81988, lon: -0.9544 },
    { lat: 50.82082, lon: -0.95359 },
    { lat: 50.82169, lon: -0.95182 },
    { lat: 50.82378, lon: -0.95099 },
    { lat: 50.82571, lon: -0.95203 },
    { lat: 50.82802, lon: -0.95232 },
    { lat: 50.83021, lon: -0.9561 },
  ],
  [
    { lat: 50.78738, lon: -1.03041 },
    { lat: 50.78913, lon: -1.02856 },
    { lat: 50.79166, lon: -1.02947 },
    { lat: 50.7952, lon: -1.0294 },
    { lat: 50.79644, lon: -1.0301 },
    { lat: 50.79664, lon: -1.03089 },
    { lat: 50.79658, lon: -1.03171 },
    { lat: 50.79571, lon: -1.03041 },
    { lat: 50.79354, lon: -1.0304 },
    { lat: 50.79253, lon: -1.03097 },
    { lat: 50.79196, lon: -1.032 },
    { lat: 50.7923, lon: -1.03421 },
    { lat: 50.79144, lon: -1.03327 },
    { lat: 50.79039, lon: -1.03573 },
    { lat: 50.7911, lon: -1.03709 },
    { lat: 50.79224, lon: -1.03461 },
    { lat: 50.78955, lon: -1.04191 },
    { lat: 50.78974, lon: -1.04382 },
    { lat: 50.79054, lon: -1.0443 },
    { lat: 50.79074, lon: -1.04278 },
    { lat: 50.79256, lon: -1.04159 },
    { lat: 50.79416, lon: -1.03953 },
    { lat: 50.79454, lon: -1.03826 },
    { lat: 50.79494, lon: -1.03827 },
    { lat: 50.79466, lon: -1.03953 },
    { lat: 50.79499, lon: -1.03831 },
    { lat: 50.79584, lon: -1.03868 },
    { lat: 50.79605, lon: -1.03796 },
    { lat: 50.8027, lon: -1.04123 },
    { lat: 50.80558, lon: -1.04204 },
    { lat: 50.80768, lon: -1.04197 },
    { lat: 50.81022, lon: -1.04049 },
    { lat: 50.81102, lon: -1.0405 },
    { lat: 50.81394, lon: -1.04232 },
    { lat: 50.81672, lon: -1.0422 },
    { lat: 50.81915, lon: -1.04288 },
    { lat: 50.82103, lon: -1.04166 },
    { lat: 50.82258, lon: -1.04134 },
    { lat: 50.82286, lon: -1.04017 },
    { lat: 50.82269, lon: -1.04151 },
    { lat: 50.82316, lon: -1.04167 },
    { lat: 50.82335, lon: -1.04074 },
    { lat: 50.82337, lon: -1.04181 },
    { lat: 50.82388, lon: -1.04202 },
    { lat: 50.8243, lon: -1.04121 },
    { lat: 50.82582, lon: -1.0421 },
    { lat: 50.82627, lon: -1.04462 },
    { lat: 50.83172, lon: -1.04421 },
    { lat: 50.83171, lon: -1.04462 },
    { lat: 50.83086, lon: -1.04488 },
    { lat: 50.83184, lon: -1.04769 },
    { lat: 50.83314, lon: -1.04908 },
    { lat: 50.83231, lon: -1.04852 },
    { lat: 50.83305, lon: -1.05361 },
    { lat: 50.83491, lon: -1.05826 },
    { lat: 50.83609, lon: -1.06525 },
    { lat: 50.83699, lon: -1.07586 },
    { lat: 50.83626, lon: -1.07827 },
    { lat: 50.83298, lon: -1.07885 },
    { lat: 50.8321, lon: -1.08039 },
    { lat: 50.83095, lon: -1.08125 },
    { lat: 50.83002, lon: -1.08355 },
    { lat: 50.82912, lon: -1.08386 },
    { lat: 50.82778, lon: -1.08333 },
    { lat: 50.82545, lon: -1.0839 },
    { lat: 50.82482, lon: -1.08449 },
    { lat: 50.82501, lon: -1.08608 },
    { lat: 50.82602, lon: -1.08618 },
    { lat: 50.82697, lon: -1.08846 },
    { lat: 50.82643, lon: -1.09002 },
    { lat: 50.82766, lon: -1.08949 },
    { lat: 50.82789, lon: -1.09031 },
    { lat: 50.82713, lon: -1.09098 },
    { lat: 50.82906, lon: -1.09297 },
    { lat: 50.82905, lon: -1.09401 },
    { lat: 50.82807, lon: -1.09325 },
    { lat: 50.82702, lon: -1.09492 },
    { lat: 50.82671, lon: -1.09849 },
    { lat: 50.82698, lon: -1.09976 },
    { lat: 50.82731, lon: -1.09919 },
    { lat: 50.8269, lon: -1.10005 },
    { lat: 50.82485, lon: -1.09956 },
    { lat: 50.82309, lon: -1.09746 },
    { lat: 50.82326, lon: -1.09479 },
    { lat: 50.82276, lon: -1.09351 },
    { lat: 50.81933, lon: -1.09241 },
    { lat: 50.81682, lon: -1.09074 },
    { lat: 50.81607, lon: -1.09091 },
    { lat: 50.81595, lon: -1.09175 },
    { lat: 50.81474, lon: -1.09112 },
    { lat: 50.81224, lon: -1.09463 },
    { lat: 50.81159, lon: -1.09449 },
    { lat: 50.81112, lon: -1.09679 },
    { lat: 50.8114, lon: -1.09444 },
    { lat: 50.81069, lon: -1.09591 },
    { lat: 50.81119, lon: -1.09199 },
    { lat: 50.81179, lon: -1.09092 },
    { lat: 50.81161, lon: -1.09047 },
    { lat: 50.80908, lon: -1.09115 },
    { lat: 50.8085, lon: -1.09408 },
    { lat: 50.81047, lon: -1.104 },
    { lat: 50.80882, lon: -1.10625 },
    { lat: 50.80841, lon: -1.10534 },
    { lat: 50.80841, lon: -1.1064 },
    { lat: 50.808, lon: -1.10646 },
    { lat: 50.80793, lon: -1.10535 },
    { lat: 50.80734, lon: -1.10567 },
    { lat: 50.8073, lon: -1.10385 },
    { lat: 50.80573, lon: -1.10371 },
    { lat: 50.80597, lon: -1.10616 },
    { lat: 50.80397, lon: -1.10619 },
    { lat: 50.80401, lon: -1.1079 },
    { lat: 50.80638, lon: -1.10795 },
    { lat: 50.8062, lon: -1.10637 },
    { lat: 50.80692, lon: -1.10773 },
    { lat: 50.80695, lon: -1.11152 },
    { lat: 50.80276, lon: -1.11161 },
    { lat: 50.80273, lon: -1.11099 },
    { lat: 50.80255, lon: -1.11176 },
    { lat: 50.80093, lon: -1.11173 },
    { lat: 50.80113, lon: -1.1108 },
    { lat: 50.79959, lon: -1.10936 },
    { lat: 50.80074, lon: -1.11088 },
    { lat: 50.80051, lon: -1.11167 },
    { lat: 50.79855, lon: -1.11125 },
    { lat: 50.79934, lon: -1.10898 },
    { lat: 50.79832, lon: -1.10717 },
    { lat: 50.79782, lon: -1.10844 },
    { lat: 50.79805, lon: -1.10686 },
    { lat: 50.79711, lon: -1.10799 },
    { lat: 50.79708, lon: -1.10572 },
    { lat: 50.79649, lon: -1.10884 },
    { lat: 50.79545, lon: -1.1087 },
    { lat: 50.79451, lon: -1.10716 },
    { lat: 50.79395, lon: -1.10837 },
    { lat: 50.79318, lon: -1.10796 },
    { lat: 50.79293, lon: -1.10621 },
    { lat: 50.79279, lon: -1.10684 },
    { lat: 50.79228, lon: -1.10526 },
    { lat: 50.79112, lon: -1.10568 },
    { lat: 50.79032, lon: -1.10687 },
    { lat: 50.79133, lon: -1.1076 },
    { lat: 50.79151, lon: -1.10603 },
    { lat: 50.79203, lon: -1.10596 },
    { lat: 50.79238, lon: -1.10779 },
    { lat: 50.79182, lon: -1.10797 },
    { lat: 50.79279, lon: -1.10826 },
    { lat: 50.79282, lon: -1.10914 },
    { lat: 50.79183, lon: -1.1098 },
    { lat: 50.79039, lon: -1.109 },
    { lat: 50.78649, lon: -1.1019 },
    { lat: 50.78632, lon: -1.10222 },
    { lat: 50.78537, lon: -1.1015 },
    { lat: 50.78468, lon: -1.09971 },
    { lat: 50.77932, lon: -1.09265 },
    { lat: 50.77763, lon: -1.08897 },
    { lat: 50.78042, lon: -1.06616 },
    { lat: 50.78316, lon: -1.05451 },
    { lat: 50.78618, lon: -1.03489 },
    { lat: 50.78738, lon: -1.03041 },
  ],
  [
    { lat: 50.80139, lon: -0.85026 },
    { lat: 50.80299, lon: -0.85574 },
    { lat: 50.80288, lon: -0.86054 },
    { lat: 50.80376, lon: -0.8608 },
    { lat: 50.80408, lon: -0.86174 },
    { lat: 50.80448, lon: -0.86171 },
    { lat: 50.80558, lon: -0.86477 },
    { lat: 50.80617, lon: -0.86404 },
    { lat: 50.80625, lon: -0.86529 },
    { lat: 50.80656, lon: -0.86558 },
    { lat: 50.80696, lon: -0.86494 },
    { lat: 50.8078, lon: -0.86615 },
    { lat: 50.8073, lon: -0.86641 },
    { lat: 50.80734, lon: -0.86708 },
    { lat: 50.80818, lon: -0.8688 },
    { lat: 50.80734, lon: -0.86921 },
    { lat: 50.80836, lon: -0.86917 },
    { lat: 50.80735, lon: -0.86955 },
    { lat: 50.80791, lon: -0.87238 },
    { lat: 50.80772, lon: -0.8776 },
    { lat: 50.80593, lon: -0.88154 },
    { lat: 50.80348, lon: -0.88358 },
    { lat: 50.80308, lon: -0.88476 },
    { lat: 50.80275, lon: -0.88464 },
    { lat: 50.80263, lon: -0.88518 },
    { lat: 50.80291, lon: -0.88462 },
    { lat: 50.80302, lon: -0.8851 },
    { lat: 50.80251, lon: -0.88536 },
    { lat: 50.80257, lon: -0.88609 },
    { lat: 50.80199, lon: -0.8867 },
    { lat: 50.80215, lon: -0.88575 },
    { lat: 50.80147, lon: -0.88726 },
    { lat: 50.8029, lon: -0.88617 },
    { lat: 50.80349, lon: -0.8839 },
    { lat: 50.8038, lon: -0.88473 },
    { lat: 50.80346, lon: -0.88585 },
    { lat: 50.80128, lon: -0.88781 },
    { lat: 50.79992, lon: -0.89063 },
    { lat: 50.79819, lon: -0.89158 },
    { lat: 50.79265, lon: -0.89279 },
    { lat: 50.79076, lon: -0.89452 },
    { lat: 50.79018, lon: -0.89449 },
    { lat: 50.78907, lon: -0.8985 },
    { lat: 50.78954, lon: -0.89917 },
    { lat: 50.789, lon: -0.8993 },
    { lat: 50.78929, lon: -0.89982 },
    { lat: 50.78889, lon: -0.90101 },
    { lat: 50.78937, lon: -0.89993 },
    { lat: 50.7891, lon: -0.8995 },
    { lat: 50.78941, lon: -0.89933 },
    { lat: 50.78977, lon: -0.89987 },
    { lat: 50.78968, lon: -0.89923 },
    { lat: 50.78989, lon: -0.89964 },
    { lat: 50.7906, lon: -0.89808 },
    { lat: 50.7903, lon: -0.89734 },
    { lat: 50.79067, lon: -0.89771 },
    { lat: 50.79073, lon: -0.89676 },
    { lat: 50.79108, lon: -0.89721 },
    { lat: 50.7901, lon: -0.89896 },
    { lat: 50.78974, lon: -0.90113 },
    { lat: 50.78738, lon: -0.90348 },
    { lat: 50.78584, lon: -0.90423 },
    { lat: 50.78482, lon: -0.90383 },
    { lat: 50.78338, lon: -0.90402 },
    { lat: 50.78196, lon: -0.90521 },
    { lat: 50.78156, lon: -0.90677 },
    { lat: 50.78198, lon: -0.9068 },
    { lat: 50.78201, lon: -0.9087 },
    { lat: 50.78057, lon: -0.9154 },
    { lat: 50.78337, lon: -0.91471 },
    { lat: 50.78608, lon: -0.91148 },
    { lat: 50.78653, lon: -0.91187 },
    { lat: 50.78704, lon: -0.91048 },
    { lat: 50.78673, lon: -0.90849 },
    { lat: 50.78864, lon: -0.91102 },
    { lat: 50.78876, lon: -0.91247 },
    { lat: 50.7892, lon: -0.91289 },
    { lat: 50.78949, lon: -0.91233 },
    { lat: 50.78969, lon: -0.9127 },
    { lat: 50.78919, lon: -0.91383 },
    { lat: 50.78805, lon: -0.9148 },
    { lat: 50.78223, lon: -0.91529 },
    { lat: 50.78099, lon: -0.91661 },
    { lat: 50.77923, lon: -0.9146 },
    { lat: 50.77621, lon: -0.9094 },
    { lat: 50.77334, lon: -0.90324 },
    { lat: 50.76325, lon: -0.86706 },
    { lat: 50.75727, lon: -0.85185 },
  ],
  [
    { lat: 50.62603, lon: -1.94979 },
    { lat: 50.62924, lon: -1.94447 },
    { lat: 50.63103, lon: -1.93302 },
    { lat: 50.63212, lon: -1.93268 },
    { lat: 50.63216, lon: -1.93193 },
    { lat: 50.6323, lon: -1.93236 },
    { lat: 50.63431, lon: -1.9311 },
    { lat: 50.63664, lon: -1.92912 },
    { lat: 50.63745, lon: -1.92753 },
    { lat: 50.63847, lon: -1.92727 },
    { lat: 50.63903, lon: -1.92612 },
    { lat: 50.63971, lon: -1.92567 },
    { lat: 50.63992, lon: -1.92595 },
    { lat: 50.64017, lon: -1.92522 },
    { lat: 50.64058, lon: -1.92563 },
    { lat: 50.64101, lon: -1.92523 },
    { lat: 50.64093, lon: -1.92429 },
    { lat: 50.64159, lon: -1.9245 },
    { lat: 50.64213, lon: -1.92371 },
    { lat: 50.64229, lon: -1.92583 },
    { lat: 50.64176, lon: -1.92743 },
    { lat: 50.6421, lon: -1.92999 },
    { lat: 50.64168, lon: -1.93078 },
    { lat: 50.64196, lon: -1.9324 },
    { lat: 50.64088, lon: -1.9409 },
    { lat: 50.64247, lon: -1.94363 },
    { lat: 50.64549, lon: -1.94713 },
    { lat: 50.64577, lon: -1.9492 },
    { lat: 50.64649, lon: -1.94999 },
  ],
  [
    { lat: 50.82614, lon: -1.01491 },
    { lat: 50.82593, lon: -1.01408 },
    { lat: 50.82553, lon: -1.01422 },
    { lat: 50.82642, lon: -1.01268 },
    { lat: 50.82666, lon: -1.01337 },
    { lat: 50.8271, lon: -1.01289 },
    { lat: 50.82678, lon: -1.01398 },
    { lat: 50.82713, lon: -1.01384 },
    { lat: 50.8272, lon: -1.01515 },
    { lat: 50.82757, lon: -1.01246 },
    { lat: 50.82801, lon: -1.0134 },
    { lat: 50.82773, lon: -1.01402 },
    { lat: 50.82831, lon: -1.01401 },
    { lat: 50.82793, lon: -1.01468 },
    { lat: 50.82814, lon: -1.01435 },
    { lat: 50.82855, lon: -1.01485 },
    { lat: 50.82834, lon: -1.01417 },
    { lat: 50.8288, lon: -1.01439 },
    { lat: 50.8287, lon: -1.01493 },
    { lat: 50.82902, lon: -1.0148 },
    { lat: 50.82821, lon: -1.01548 },
    { lat: 50.82848, lon: -1.01572 },
    { lat: 50.82791, lon: -1.01707 },
    { lat: 50.82665, lon: -1.01456 },
    { lat: 50.82614, lon: -1.01491 },
  ],
  [
    { lat: 50.82347, lon: -1.00677 },
    { lat: 50.8232, lon: -1.00831 },
    { lat: 50.82367, lon: -1.00874 },
    { lat: 50.8241, lon: -1.0082 },
    { lat: 50.82392, lon: -1.009 },
    { lat: 50.82455, lon: -1.00886 },
    { lat: 50.82428, lon: -1.0094 },
    { lat: 50.82473, lon: -1.00954 },
    { lat: 50.82542, lon: -1.00885 },
    { lat: 50.82461, lon: -1.00833 },
    { lat: 50.8249, lon: -1.00712 },
    { lat: 50.82497, lon: -1.00813 },
    { lat: 50.82619, lon: -1.00892 },
    { lat: 50.82652, lon: -1.00976 },
    { lat: 50.82564, lon: -1.01042 },
    { lat: 50.82383, lon: -1.01066 },
    { lat: 50.82235, lon: -1.00901 },
    { lat: 50.82189, lon: -1.00759 },
    { lat: 50.82303, lon: -1.00715 },
    { lat: 50.82371, lon: -1.00614 },
    { lat: 50.82347, lon: -1.00677 },
  ],
  [
    { lat: 50.7805, lon: -1.38186 },
    { lat: 50.77973, lon: -1.38316 },
    { lat: 50.78038, lon: -1.38302 },
    { lat: 50.77998, lon: -1.38487 },
    { lat: 50.77969, lon: -1.38525 },
    { lat: 50.77971, lon: -1.38463 },
    { lat: 50.77964, lon: -1.3852 },
    { lat: 50.77931, lon: -1.38493 },
    { lat: 50.77974, lon: -1.38546 },
    { lat: 50.77956, lon: -1.38605 },
    { lat: 50.77921, lon: -1.38658 },
    { lat: 50.77884, lon: -1.3864 },
    { lat: 50.77928, lon: -1.38689 },
    { lat: 50.77827, lon: -1.38899 },
    { lat: 50.77869, lon: -1.389 },
    { lat: 50.77824, lon: -1.39023 },
    { lat: 50.77746, lon: -1.38947 },
    { lat: 50.77841, lon: -1.3857 },
    { lat: 50.78076, lon: -1.37972 },
    { lat: 50.7805, lon: -1.38186 },
  ],
  [
    { lat: 50.70612, lon: -1.94994 },
    { lat: 50.70666, lon: -1.9485 },
    { lat: 50.70731, lon: -1.94817 },
    { lat: 50.70714, lon: -1.94778 },
    { lat: 50.70662, lon: -1.9484 },
    { lat: 50.70634, lon: -1.94687 },
    { lat: 50.70378, lon: -1.94443 },
    { lat: 50.70113, lon: -1.94077 },
    { lat: 50.70059, lon: -1.93636 },
    { lat: 50.70001, lon: -1.93493 },
    { lat: 50.6978, lon: -1.93309 },
    { lat: 50.69678, lon: -1.93339 },
    { lat: 50.69623, lon: -1.93213 },
    { lat: 50.69487, lon: -1.93176 },
    { lat: 50.69299, lon: -1.93298 },
    { lat: 50.68878, lon: -1.94055 },
    { lat: 50.68825, lon: -1.94519 },
    { lat: 50.68852, lon: -1.94671 },
    { lat: 50.68716, lon: -1.94998 },
  ],
  [
    { lat: 50.83313, lon: -1.00854 },
    { lat: 50.83337, lon: -1.00577 },
    { lat: 50.83226, lon: -1.00693 },
    { lat: 50.83159, lon: -1.00639 },
    { lat: 50.83174, lon: -1.0055 },
    { lat: 50.83197, lon: -1.00601 },
    { lat: 50.8323, lon: -1.00548 },
    { lat: 50.83168, lon: -1.00534 },
    { lat: 50.83143, lon: -1.0061 },
    { lat: 50.83124, lon: -1.00348 },
    { lat: 50.83018, lon: -1.0035 },
    { lat: 50.82949, lon: -1.0028 },
    { lat: 50.8299, lon: -1.00172 },
    { lat: 50.83395, lon: -1.00545 },
    { lat: 50.83437, lon: -1.00747 },
    { lat: 50.83399, lon: -1.00667 },
    { lat: 50.83394, lon: -1.00864 },
    { lat: 50.83336, lon: -1.00903 },
    { lat: 50.83313, lon: -1.00854 },
  ],
  [
    { lat: 50.81531, lon: -1.09262 },
    { lat: 50.81914, lon: -1.09426 },
    { lat: 50.82044, lon: -1.09578 },
    { lat: 50.82058, lon: -1.09697 },
    { lat: 50.81984, lon: -1.09864 },
    { lat: 50.81806, lon: -1.09966 },
    { lat: 50.81553, lon: -1.10019 },
    { lat: 50.81368, lon: -1.10168 },
    { lat: 50.81341, lon: -1.10022 },
    { lat: 50.81408, lon: -1.09673 },
    { lat: 50.81369, lon: -1.09632 },
    { lat: 50.81417, lon: -1.09635 },
    { lat: 50.81495, lon: -1.09277 },
    { lat: 50.81531, lon: -1.09262 },
  ],
  [
    { lat: 50.78521, lon: -1.40727 },
    { lat: 50.78429, lon: -1.40579 },
    { lat: 50.78233, lon: -1.39976 },
    { lat: 50.78291, lon: -1.39638 },
    { lat: 50.78303, lon: -1.39671 },
    { lat: 50.78327, lon: -1.39643 },
    { lat: 50.78338, lon: -1.39508 },
    { lat: 50.78411, lon: -1.39461 },
    { lat: 50.78467, lon: -1.3948 },
    { lat: 50.78363, lon: -1.3955 },
    { lat: 50.78247, lon: -1.39972 },
    { lat: 50.78521, lon: -1.40727 },
  ],
  [
    { lat: 50.83503, lon: -0.9445 },
    { lat: 50.83513, lon: -0.94571 },
    { lat: 50.83457, lon: -0.94602 },
    { lat: 50.83509, lon: -0.94691 },
    { lat: 50.83458, lon: -0.9468 },
    { lat: 50.83433, lon: -0.94488 },
    { lat: 50.8348, lon: -0.94438 },
    { lat: 50.83453, lon: -0.94589 },
    { lat: 50.83506, lon: -0.94572 },
    { lat: 50.83498, lon: -0.94501 },
    { lat: 50.8345, lon: -0.94507 },
    { lat: 50.83503, lon: -0.9445 },
  ],
  [
    { lat: 50.8266, lon: -1.11432 },
    { lat: 50.82763, lon: -1.11521 },
    { lat: 50.82792, lon: -1.11658 },
    { lat: 50.82752, lon: -1.11641 },
    { lat: 50.8274, lon: -1.11536 },
    { lat: 50.82517, lon: -1.11299 },
    { lat: 50.82515, lon: -1.11202 },
    { lat: 50.82622, lon: -1.11234 },
    { lat: 50.82601, lon: -1.11315 },
    { lat: 50.8266, lon: -1.11432 },
  ],
  [
    { lat: 50.8102, lon: -0.85023 },
    { lat: 50.80973, lon: -0.8513 },
    { lat: 50.8101, lon: -0.85452 },
    { lat: 50.80957, lon: -0.85599 },
    { lat: 50.80798, lon: -0.857 },
    { lat: 50.8071, lon: -0.85612 },
    { lat: 50.80713, lon: -0.85414 },
    { lat: 50.80584, lon: -0.85011 },
  ],
  [
    { lat: 50.83488, lon: -1.01035 },
    { lat: 50.8364, lon: -1.01163 },
    { lat: 50.8363, lon: -1.01327 },
    { lat: 50.83736, lon: -1.01523 },
    { lat: 50.83701, lon: -1.017 },
    { lat: 50.83691, lon: -1.01557 },
    { lat: 50.83569, lon: -1.01411 },
    { lat: 50.83488, lon: -1.01035 },
  ],
];

/** Combined coastline for AreaData.coastline. Index 0 is the mainland;
 *  the rest are closed island polygons. */
export const SOLENT_COASTLINE: ReadonlyArray<ReadonlyArray<LatLon>> = [
  SOLENT_MAINLAND,
  ...SOLENT_ISLANDS,
];
